// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/bg/page-bg-dark-2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto+Slab:wght@300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
************
*************************

Template Name: Name - Bostami - Personal Portfolio NextJs Template
Description: Bostami – HTML Personal Portfolio Template can be used for many purposes. It’s a creative, minimal and clean design.It’s suitable for Designer, Developer, Specialist, Content Writer, Instructor, Photographer, Freelancer, Software Engineer, Teacher or others expert who Show their professional projects and services in digital way. It’s 100% responsive and Ultra Super Fast beacause it’s made with Latest html
Author: elite-themes24
Version: 1.0

-----------------------------------------------------------------------------------

CSS INDEX
=================== 
01. common
02. button
03. page
04. header
05. parsonal info
06. client
07. what do
08. resume
09. portfolio
10. blog
11. contact
12. preloader
13. blog details
14. sidebar
15. dark theme

******************************************************* 
*************************************************************** */
/*
************
*************************
01. common
******************************************************* 
*************************************************************** */
:root {
  --common-white: #ffffff;
  --common-white-two: #ffffff;
  --common-black: #000;
  --theme-primary: #1b74e4;
  --theme-secondary: #fa5252;
  --body-text: #44566c;
  --body-heading: #000;
  --heading-black: #0f172a;
  --light-white: #f3f6f6;
  --light-white-2: #f8fbfb;
  --prink: #fff4f4;
  --catkrill: #eef5fa;
  --background-image: none;
  /* Imagen por defecto */
  background-image: var(--background-image);
}

:root .dark-theme {
  --common-white: #000;
  --common-black: #fff;
  --theme-primary: #1b74e4;
  --theme-secondary: #fa5252;
  --body-text: #a6a6a6;
  --body-heading: #fff;
  --heading-black: #0f172a;
  --light-white: #f3f6f6;
  --light-white-2: #f8fbfb;
  --prink: #fff4f4;
  --catkrill: #eef5fa;
}

body {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--body-text);
  font-size: 16px;
  line-height: 28px;
}

.dark-theme {
  background-color: #1a1a1a;
}

.img,
img {
  max-width: 100%;
  transition: 0.3s;
}

a,
.button,
button {
  transition: 0.3s;
}

a:focus,
.button:focus {
  text-decoration: none;
  outline: none;
}

a:focus,
a:hover {
  color: inherit;
  text-decoration: none;
}

a,
button {
  color: inherit;
  outline: medium none;
  text-decoration: none;
}

button:focus,
input:focus,
input:focus,
textarea,
textarea:focus {
  outline: 0;
}

.uppercase {
  text-transform: uppercase;
}

.capitalize {
  text-transform: capitalize;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins", sans-serif;
  color: var(--body-heading);
  margin-top: 0px;
  line-height: 1.5;
  font-weight: 700;
  text-transform: capitalize;
  margin-bottom: 15px;
}

h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a {
  color: inherit;
}

h1 {
  font-size: 60px;
}

h2 {
  font-size: 40px;
}

h3 {
  font-size: 28px;
}

h4 {
  font-size: 26px;
}

h5 {
  font-size: 22px;
}

h6 {
  font-size: 16px;
}

ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

p {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 27px;
  color: var(--body-text);
}

hr {
  border-bottom: 1px solid var(--clr-bg-gray-3);
  border-top: 0 none;
  padding: 0;
  opacity: 1;
}

label {
  color: var(--clr-common-black);
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
}

::selection {
  background-color: #037fff;
  color: #fff;
  text-shadow: none;
}

/* <<<<<<<    Input Placeholder   >>>>>>>>> */

input:focus::placeholder,
textarea:focus::placeholder {
  opacity: 0;
}

/* <<<<<<<    Common Classes   >>>>>>>>> */
.w_img img {
  width: 100%;
}

/* <<<<<<<    Overlay   >>>>>>>>> */
[data-overlay] {
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

[data-overlay]::before {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  content: "";
}

/* <<<<<<<    Margin & Padding     >>>>>>>>> */
.mt-5 {
  margin-top: 5px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-15 {
  margin-top: 15px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-25 {
  margin-top: 25px;
}

.mt-30 {
  margin-top: 30px;
}

.mt-35 {
  margin-top: 35px;
}

.mt-40 {
  margin-top: 40px;
}

.mt-45 {
  margin-top: 45px;
}

.mt-50 {
  margin-top: 50px;
}

.mt-55 {
  margin-top: 55px;
}

.mt-60 {
  margin-top: 60px;
}

.mt-65 {
  margin-top: 65px;
}

.mt-70 {
  margin-top: 70px;
}

.mt-75 {
  margin-top: 75px;
}

.mt-80 {
  margin-top: 80px;
}

.mt-85 {
  margin-top: 85px;
}

.mt-90 {
  margin-top: 90px;
}

.mt-95 {
  margin-top: 95px;
}

.mt-100 {
  margin-top: 100px;
}

.mt-105 {
  margin-top: 105px;
}

.mt-110 {
  margin-top: 110px;
}

.mt-115 {
  margin-top: 115px;
}

.mt-120 {
  margin-top: 120px;
}

.mt-125 {
  margin-top: 125px;
}

.mt-130 {
  margin-top: 130px;
}

.mt-135 {
  margin-top: 135px;
}

.mt-140 {
  margin-top: 140px;
}

.mt-145 {
  margin-top: 145px;
}

.mt-150 {
  margin-top: 150px;
}

.mt-155 {
  margin-top: 155px;
}

.mt-160 {
  margin-top: 160px;
}

.mt-165 {
  margin-top: 165px;
}

.mt-170 {
  margin-top: 170px;
}

.mt-175 {
  margin-top: 175px;
}

.mt-180 {
  margin-top: 180px;
}

.mt-185 {
  margin-top: 185px;
}

.mt-190 {
  margin-top: 190px;
}

.mt-195 {
  margin-top: 195px;
}

.mt-200 {
  margin-top: 200px;
}

.mb-5 {
  margin-bottom: 5px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-15 {
  margin-bottom: 15px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-25 {
  margin-bottom: 25px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-35 {
  margin-bottom: 35px;
}

.mb-40 {
  margin-bottom: 40px;
}

.mb-45 {
  margin-bottom: 45px;
}

.mb-50 {
  margin-bottom: 50px;
}

.mb-55 {
  margin-bottom: 55px;
}

.mb-60 {
  margin-bottom: 60px;
}

.mb-65 {
  margin-bottom: 65px;
}

.mb-70 {
  margin-bottom: 70px;
}

.mb-75 {
  margin-bottom: 75px;
}

.mb-80 {
  margin-bottom: 80px;
}

.mb-85 {
  margin-bottom: 85px;
}

.mb-90 {
  margin-bottom: 90px;
}

.mb-95 {
  margin-bottom: 95px;
}

.mb-100 {
  margin-bottom: 100px;
}

.mb-105 {
  margin-bottom: 105px;
}

.mb-110 {
  margin-bottom: 110px;
}

.mb-115 {
  margin-bottom: 115px;
}

.mb-120 {
  margin-bottom: 120px;
}

.mb-125 {
  margin-bottom: 125px;
}

.mb-130 {
  margin-bottom: 130px;
}

.mb-135 {
  margin-bottom: 135px;
}

.mb-140 {
  margin-bottom: 140px;
}

.mb-145 {
  margin-bottom: 145px;
}

.mb-150 {
  margin-bottom: 150px;
}

.mb-155 {
  margin-bottom: 155px;
}

.mb-160 {
  margin-bottom: 160px;
}

.mb-165 {
  margin-bottom: 165px;
}

.mb-170 {
  margin-bottom: 170px;
}

.mb-175 {
  margin-bottom: 175px;
}

.mb-180 {
  margin-bottom: 180px;
}

.mb-185 {
  margin-bottom: 185px;
}

.mb-190 {
  margin-bottom: 190px;
}

.mb-195 {
  margin-bottom: 195px;
}

.mb-200 {
  margin-bottom: 200px;
}

.ml-5 {
  margin-left: 5px;
}

.ml-10 {
  margin-left: 10px;
}

.ml-15 {
  margin-left: 15px;
}

.ml-20 {
  margin-left: 20px;
}

.ml-25 {
  margin-left: 25px;
}

.ml-30 {
  margin-left: 30px;
}

.ml-35 {
  margin-left: 35px;
}

.ml-40 {
  margin-left: 40px;
}

.ml-45 {
  margin-left: 45px;
}

.ml-50 {
  margin-left: 50px;
}

.ml-55 {
  margin-left: 55px;
}

.ml-60 {
  margin-left: 60px;
}

.ml-65 {
  margin-left: 65px;
}

.ml-70 {
  margin-left: 70px;
}

.ml-75 {
  margin-left: 75px;
}

.ml-80 {
  margin-left: 80px;
}

.ml-85 {
  margin-left: 85px;
}

.ml-90 {
  margin-left: 90px;
}

.ml-95 {
  margin-left: 95px;
}

.ml-100 {
  margin-left: 100px;
}

.ml-105 {
  margin-left: 105px;
}

.ml-110 {
  margin-left: 110px;
}

.ml-115 {
  margin-left: 115px;
}

.ml-120 {
  margin-left: 120px;
}

.ml-125 {
  margin-left: 125px;
}

.ml-130 {
  margin-left: 130px;
}

.ml-135 {
  margin-left: 135px;
}

.ml-140 {
  margin-left: 140px;
}

.ml-145 {
  margin-left: 145px;
}

.ml-150 {
  margin-left: 150px;
}

.ml-155 {
  margin-left: 155px;
}

.ml-160 {
  margin-left: 160px;
}

.ml-165 {
  margin-left: 165px;
}

.ml-170 {
  margin-left: 170px;
}

.ml-175 {
  margin-left: 175px;
}

.ml-180 {
  margin-left: 180px;
}

.ml-185 {
  margin-left: 185px;
}

.ml-190 {
  margin-left: 190px;
}

.ml-195 {
  margin-left: 195px;
}

.ml-200 {
  margin-left: 200px;
}

.mr-5 {
  margin-right: 5px;
}

.mr-10 {
  margin-right: 10px;
}

.mr-15 {
  margin-right: 15px;
}

.mr-20 {
  margin-right: 20px;
}

.mr-25 {
  margin-right: 25px;
}

.mr-30 {
  margin-right: 30px;
}

.mr-35 {
  margin-right: 35px;
}

.mr-40 {
  margin-right: 40px;
}

.mr-45 {
  margin-right: 45px;
}

.mr-50 {
  margin-right: 50px;
}

.mr-55 {
  margin-right: 55px;
}

.mr-60 {
  margin-right: 60px;
}

.mr-65 {
  margin-right: 65px;
}

.mr-70 {
  margin-right: 70px;
}

.mr-75 {
  margin-right: 75px;
}

.mr-80 {
  margin-right: 80px;
}

.mr-85 {
  margin-right: 85px;
}

.mr-90 {
  margin-right: 90px;
}

.mr-95 {
  margin-right: 95px;
}

.mr-100 {
  margin-right: 100px;
}

.mr-105 {
  margin-right: 105px;
}

.mr-110 {
  margin-right: 110px;
}

.mr-115 {
  margin-right: 115px;
}

.mr-120 {
  margin-right: 120px;
}

.mr-125 {
  margin-right: 125px;
}

.mr-130 {
  margin-right: 130px;
}

.mr-135 {
  margin-right: 135px;
}

.mr-140 {
  margin-right: 140px;
}

.mr-145 {
  margin-right: 145px;
}

.mr-150 {
  margin-right: 150px;
}

.mr-155 {
  margin-right: 155px;
}

.mr-160 {
  margin-right: 160px;
}

.mr-165 {
  margin-right: 165px;
}

.mr-170 {
  margin-right: 170px;
}

.mr-175 {
  margin-right: 175px;
}

.mr-180 {
  margin-right: 180px;
}

.mr-185 {
  margin-right: 185px;
}

.mr-190 {
  margin-right: 190px;
}

.mr-195 {
  margin-right: 195px;
}

.mr-200 {
  margin-right: 200px;
}

.pt-5 {
  padding-top: 5px;
}

.pt-10 {
  padding-top: 10px;
}

.pt-15 {
  padding-top: 15px;
}

.pt-20 {
  padding-top: 20px;
}

.pt-25 {
  padding-top: 25px;
}

.pt-30 {
  padding-top: 30px;
}

.pt-35 {
  padding-top: 35px;
}

.pt-40 {
  padding-top: 40px;
}

.pt-45 {
  padding-top: 45px;
}

.pt-50 {
  padding-top: 50px;
}

.pt-55 {
  padding-top: 55px;
}

.pt-60 {
  padding-top: 60px;
}

.pt-65 {
  padding-top: 65px;
}

.pt-70 {
  padding-top: 70px;
}

.pt-75 {
  padding-top: 75px;
}

.pt-80 {
  padding-top: 80px;
}

.pt-85 {
  padding-top: 85px;
}

.pt-90 {
  padding-top: 90px;
}

.pt-95 {
  padding-top: 95px;
}

.pt-100 {
  padding-top: 100px;
}

.pt-105 {
  padding-top: 105px;
}

.pt-110 {
  padding-top: 110px;
}

.pt-115 {
  padding-top: 115px;
}

.pt-120 {
  padding-top: 120px;
}

.pt-125 {
  padding-top: 125px;
}

.pt-130 {
  padding-top: 130px;
}

.pt-135 {
  padding-top: 135px;
}

.pt-140 {
  padding-top: 140px;
}

.pt-145 {
  padding-top: 145px;
}

.pt-150 {
  padding-top: 150px;
}

.pt-155 {
  padding-top: 155px;
}

.pt-160 {
  padding-top: 160px;
}

.pt-165 {
  padding-top: 165px;
}

.pt-170 {
  padding-top: 170px;
}

.pt-175 {
  padding-top: 175px;
}

.pt-180 {
  padding-top: 180px;
}

.pt-185 {
  padding-top: 185px;
}

.pt-190 {
  padding-top: 190px;
}

.pt-195 {
  padding-top: 195px;
}

.pt-200 {
  padding-top: 200px;
}

.pb-5 {
  padding-bottom: 5px;
}

.pb-10 {
  padding-bottom: 10px;
}

.pb-15 {
  padding-bottom: 15px;
}

.pb-20 {
  padding-bottom: 20px;
}

.pb-25 {
  padding-bottom: 25px;
}

.pb-30 {
  padding-bottom: 30px;
}

.pb-35 {
  padding-bottom: 35px;
}

.pb-40 {
  padding-bottom: 40px;
}

.pb-45 {
  padding-bottom: 45px;
}

.pb-50 {
  padding-bottom: 50px;
}

.pb-55 {
  padding-bottom: 55px;
}

.pb-60 {
  padding-bottom: 60px;
}

.pb-65 {
  padding-bottom: 65px;
}

.pb-70 {
  padding-bottom: 70px;
}

.pb-75 {
  padding-bottom: 75px;
}

.pb-80 {
  padding-bottom: 80px;
}

.pb-85 {
  padding-bottom: 85px;
}

.pb-90 {
  padding-bottom: 90px;
}

.pb-95 {
  padding-bottom: 95px;
}

.pb-100 {
  padding-bottom: 100px;
}

.pb-105 {
  padding-bottom: 105px;
}

.pb-110 {
  padding-bottom: 110px;
}

.pb-115 {
  padding-bottom: 115px;
}

.pb-120 {
  padding-bottom: 120px;
}

.pb-125 {
  padding-bottom: 125px;
}

.pb-130 {
  padding-bottom: 130px;
}

.pb-135 {
  padding-bottom: 135px;
}

.pb-140 {
  padding-bottom: 140px;
}

.pb-145 {
  padding-bottom: 145px;
}

.pb-150 {
  padding-bottom: 150px;
}

.pb-155 {
  padding-bottom: 155px;
}

.pb-160 {
  padding-bottom: 160px;
}

.pb-165 {
  padding-bottom: 165px;
}

.pb-170 {
  padding-bottom: 170px;
}

.pb-175 {
  padding-bottom: 175px;
}

.pb-180 {
  padding-bottom: 180px;
}

.pb-185 {
  padding-bottom: 185px;
}

.pb-190 {
  padding-bottom: 190px;
}

.pb-195 {
  padding-bottom: 195px;
}

.pb-200 {
  padding-bottom: 200px;
}

.pb-205 {
  padding-bottom: 205px;
}

.pb-210 {
  padding-bottom: 210px;
}

.pb-215 {
  padding-bottom: 215px;
}

.pb-220 {
  padding-bottom: 220px;
}

.pb-225 {
  padding-bottom: 225px;
}

.pb-230 {
  padding-bottom: 230px;
}

.pb-235 {
  padding-bottom: 235px;
}

.pb-240 {
  padding-bottom: 240px;
}

.pb-245 {
  padding-bottom: 245px;
}

.pb-250 {
  padding-bottom: 250px;
}

.pb-255 {
  padding-bottom: 255px;
}

.pb-260 {
  padding-bottom: 260px;
}

.pb-265 {
  padding-bottom: 265px;
}

.pb-270 {
  padding-bottom: 270px;
}

.pb-275 {
  padding-bottom: 275px;
}

.pb-280 {
  padding-bottom: 280px;
}

.pb-285 {
  padding-bottom: 285px;
}

.pb-290 {
  padding-bottom: 290px;
}

.pb-295 {
  padding-bottom: 295px;
}

.pb-300 {
  padding-bottom: 300px;
}

.pl-5 {
  padding-left: 5px;
}

.pl-10 {
  padding-left: 10px;
}

.pl-15 {
  padding-left: 15px;
}

.pl-20 {
  padding-left: 20px;
}

.pl-25 {
  padding-left: 25px;
}

.pl-30 {
  padding-left: 30px;
}

.pl-35 {
  padding-left: 35px;
}

.pl-40 {
  padding-left: 40px;
}

.pl-45 {
  padding-left: 45px;
}

.pl-50 {
  padding-left: 50px;
}

.pl-55 {
  padding-left: 55px;
}

.pl-60 {
  padding-left: 60px;
}

.pl-65 {
  padding-left: 65px;
}

.pl-70 {
  padding-left: 70px;
}

.pl-75 {
  padding-left: 75px;
}

.pl-80 {
  padding-left: 80px;
}

.pl-85 {
  padding-left: 85px;
}

.pl-90 {
  padding-left: 90px;
}

.pl-95 {
  padding-left: 95px;
}

.pl-100 {
  padding-left: 100px;
}

.pl-105 {
  padding-left: 105px;
}

.pl-110 {
  padding-left: 110px;
}

.pl-115 {
  padding-left: 115px;
}

.pl-120 {
  padding-left: 120px;
}

.pl-125 {
  padding-left: 125px;
}

.pl-130 {
  padding-left: 130px;
}

.pl-135 {
  padding-left: 135px;
}

.pl-140 {
  padding-left: 140px;
}

.pl-145 {
  padding-left: 145px;
}

.pl-150 {
  padding-left: 150px;
}

.pl-155 {
  padding-left: 155px;
}

.pl-160 {
  padding-left: 160px;
}

.pl-165 {
  padding-left: 165px;
}

.pl-170 {
  padding-left: 170px;
}

.pl-175 {
  padding-left: 175px;
}

.pl-180 {
  padding-left: 180px;
}

.pl-185 {
  padding-left: 185px;
}

.pl-190 {
  padding-left: 190px;
}

.pl-195 {
  padding-left: 195px;
}

.pl-200 {
  padding-left: 200px;
}

.pr-5 {
  padding-right: 5px;
}

.pr-10 {
  padding-right: 10px;
}

.pr-15 {
  padding-right: 15px;
}

.pr-20 {
  padding-right: 20px;
}

.pr-25 {
  padding-right: 25px;
}

.pr-30 {
  padding-right: 30px;
}

.pr-35 {
  padding-right: 35px;
}

.pr-40 {
  padding-right: 40px;
}

.pr-45 {
  padding-right: 45px;
}

.pr-50 {
  padding-right: 50px;
}

.pr-55 {
  padding-right: 55px;
}

.pr-60 {
  padding-right: 60px;
}

.pr-65 {
  padding-right: 65px;
}

.pr-70 {
  padding-right: 70px;
}

.pr-75 {
  padding-right: 75px;
}

.pr-80 {
  padding-right: 80px;
}

.pr-85 {
  padding-right: 85px;
}

.pr-90 {
  padding-right: 90px;
}

.pr-95 {
  padding-right: 95px;
}

.pr-100 {
  padding-right: 100px;
}

.pr-105 {
  padding-right: 105px;
}

.pr-110 {
  padding-right: 110px;
}

.pr-115 {
  padding-right: 115px;
}

.pr-120 {
  padding-right: 120px;
}

.pr-125 {
  padding-right: 125px;
}

.pr-130 {
  padding-right: 130px;
}

.pr-135 {
  padding-right: 135px;
}

.pr-140 {
  padding-right: 140px;
}

.pr-145 {
  padding-right: 145px;
}

.pr-150 {
  padding-right: 150px;
}

.pr-155 {
  padding-right: 155px;
}

.pr-160 {
  padding-right: 160px;
}

.pr-165 {
  padding-right: 165px;
}

.pr-170 {
  padding-right: 170px;
}

.pr-175 {
  padding-right: 175px;
}

.pr-180 {
  padding-right: 180px;
}

.pr-185 {
  padding-right: 185px;
}

.pr-190 {
  padding-right: 190px;
}

.pr-195 {
  padding-right: 195px;
}

.pr-200 {
  padding-right: 200px;
}

.container {
  padding-right: 15px;
  padding-left: 15px;
}

.row {
  --bs-gutter-x: 30px;
}

.row.g-0 {
  --bs-gutter-x: 0;
}

@media (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}
/* <<<<<<<    Declaration   >>>>>>>>> */
.bg-catkrill {
  background-color: var(--catkrill);
}

.bg-prink {
  background-color: var(--prink);
}

.bg-light-white-2 {
  background-color: var(--light-white-2);
}

.bg-default {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.no-after::after {
  display: none;
}

.p-relative {
  position: relative;
}

.z-index-3 {
  position: relative;
  z-index: 3;
}

.z-index-5 {
  position: relative;
  z-index: 5;
}

.w-60 {
  width: 60%;
}

.w-80 {
  width: 80%;
}

.w-85 {
  width: 85%;
}

.w-90 {
  width: 90%;
}

.w-94 {
  width: 94%;
}

.gap-30 {
  gap: 30px;
}

.modal-backdrop.fade.show {
  display: none;
}

/*
************
*************************
02. button
******************************************************* 
*************************************************************** */
.btn-1 {
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  text-transform: capitalize;
  color: var(--common-white);
  background-color: var(--theme-primary);
  line-height: 27px;
  padding: 14px 30px;
  border-radius: 10px;
  border: 1px solid transparent;
}

.btn-1 .icon {
  display: inline-block;
  margin-right: 5px;
}

.btn-1 .icon {
  transition: 0.3s;
}

.btn-1:focus {
  color: var(--common-white-two);
}

.btn-1:hover {
  background-color: var(--light-white);
  border: 1px solid var(--theme-primary);
  color: var(--common-black);
}

.btn-1:hover .icon {
  color: var(--common-black) !important;
}

.btn-2 {
  display: inline-block;
  font-size: 18px;
  font-weight: 400;
  text-transform: capitalize;
  color: var(--common-white);
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
  line-height: 27px;
  padding: 12px 30px;
  border-radius: 10px;
  border: 1px solid transparent;
  transition: 0.3s;
}

.btn-2 .icon {
  display: inline-block;
  margin-right: 5px;
}

.btn-2 .icon svg * {
  transition: 0.3s;
}

.btn-2:hover,
.btn-2:focus {
  background: linear-gradient(80deg, #fa5252 0%, #e12a72 100%);
  border: 1px solid linear-gradient(97deg, rgb(201, 93, 93) 0%, rgb(221, 36, 118) 100%);
  color: var(--light-white);
  transform: translateY(-2px);
}

.btn-2:hover .icon svg * {
  fill: var(--light-white);
}

.dark-btn {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 23px;
  text-align: center;
  background-color: var(--common-white);
  border-radius: 50%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  margin-right: 10px;
}

.dark-btn:hover {
  background-color: var(--theme-secondary);
}

.home-3 .dark-btn {
  width: 50px;
  height: 50px;
  line-height: 48px;
  cursor: pointer;
}

.home-1 .dark-btn {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.home-1 .dark-btn:hover {
  background-color: #1b74e4;
}

.dark-btn.dark-btn-2 {
  width: 45px;
  height: 45px;
  display: flex;
  margin-right: 0;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.dark-btn.dark-btn-2:hover img {
  transform: 0.3s;
}

.dark-btn.dark-btn-2:hover img {
  filter: invert(1);
}

.form-btn {
  font-size: 16px;
  font-weight: 500;
  display: inline-block;
  text-transform: capitalize;
  color: #1a1a1a;
  height: 50px;
  width: 133px;
  border: 1px solid #44566c;
  border-radius: 12px;
  background-color: var(--light-white-2);
}

.form-btn:hover {
  background-color: var(--theme-primary);
  border-color: var(--theme-primary);
  color: #fff;
}

.page-wrapper-2 .form-btn:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
  border-color: transparent;
}

.home-3 .form-btn:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
  border-color: transparent;
}

/*
************
*************************
03. page
******************************************************* 
*************************************************************** */
.page-wrapper {
  height: 100vh;
  width: 100vw;
  display: block;
  background-position: center center;
  background-size: cover;
  /* position: fixed; */
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 0px;
  padding-bottom: 120px;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .page-wrapper {
    padding-top: 120px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .page-wrapper {
    padding-top: 120px;
  }
}
.page-wrapper.page-wrapper-2 {
  padding-top: 30px;
  padding-bottom: 60px;
}

.page-wrapper.page-wrapper-2.inner-page {
  padding-bottom: 0;
}

.bostami-page-title-wrap p {
  max-width: 632px;
}

.page-title {
  position: relative;
  display: inline-block;
  font-family: Roboto Slab, serif;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px), lg, only screen and (min-width: 768px) and (max-width: 991px) {
  .page-title {
    font-size: 36px;
  }
}
@media (max-width: 767px) {
  .page-title {
    font-size: 32px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .page-title {
    font-size: 34px;
  }
}
.page-title::after {
  content: "";
  position: absolute;
  width: 200px;
  height: 3px;
  background-color: var(--theme-primary);
  left: 122%;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 5px;
  margin-bottom: 30px;
}

@media (max-width: 767px) {
  .page-title::after {
    width: 70%;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .page-title::after {
    width: 100%;
  }
}
.bostami-page-content-wrap {
  background-color: var(--common-white);
  border-radius: 20px;
}

.bostami-section-title-wrap .section-title {
  margin-bottom: 0;
  font-weight: 500;
}

.bostami-section-title-wrap .section-title img {
  margin-right: 6px;
  margin-top: -5px;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 992px) and (max-width: 1199px), md, (max-width: 767px) {
  .bostami-section-title-wrap .section-title {
    font-size: 24px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .section-wrapper:is(.pl-60) {
    padding-left: 40px;
  }
}
@media (max-width: 767px) {
  .section-wrapper:is(.pl-60) {
    padding-left: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .section-wrapper:is(.pr-60) {
    padding-right: 40px;
  }
}
@media (max-width: 767px) {
  .section-wrapper:is(.pr-60) {
    padding-right: 20px;
  }
}
.bostami-page-area .bostami-page-wrap {
  background: #fff;
  border-radius: 20px;
}

@media only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px) {
  .bostami-page-area .bostami-page-wrap:is(.pl-80) {
    padding-left: 40px;
  }
}
@media (max-width: 767px) {
  .bostami-page-area .bostami-page-wrap:is(.pl-80) {
    padding-left: 20px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .bostami-page-area .bostami-page-wrap:is(.pl-80) {
    padding-left: 30px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px) {
  .bostami-page-area .bostami-page-wrap:is(.pr-80) {
    padding-right: 40px;
  }
}
@media (max-width: 767px) {
  .bostami-page-area .bostami-page-wrap:is(.pr-80) {
    padding-right: 20px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .bostami-page-area .bostami-page-wrap:is(.pr-80) {
    padding-right: 30px;
  }
}
.bostami-page-area .bostami-parsonal-info-contact .title {
  font-weight: 500;
}

.bostami-page-area .section-title {
  font-weight: 500;
}

.bostami-page-area .bostami-parsonal-info-title {
  font-weight: 500;
  margin-bottom: 11px;
}

.bostami-page-area .page-title::after {
  background: rgb(250, 82, 82);
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

@media (max-width: 767px) {
  .bostami-page-area .page-title::after {
    width: 40%;
  }
}
.bostami-page-area .bostami-parsonal-info-img {
  width: 100%;
  height: 400px;
  margin: 0;
  border-radius: 30px;
  margin-bottom: 80px;
}

.bostami-page-area .bostami-parsonal-info-contact {
  background: transparent;
  padding: 20px 0px;
  margin-top: -13px;
}

.footer-wrap span {
  display: block;
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  color: #44566c;
  padding: 20px 0;
}

.home-3 .page-title::after {
  /* background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%); */
  background-color: var(--theme-primary);
}

.page-wrapper.home-3 {
  padding-top: 20px;
  padding-bottom: 40px;
}

.home-3 .bostami-header-area {
  margin-bottom: 150px;
  background-color: transparent;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .home-3 .bostami-header-area {
    margin-bottom: 40px;
  }
}
.home-3 .bostami-header-area .bostami-header-wrap {
  background-color: transparent;
}

.page-wrapper.home-1 {
  padding-top: 50px;
  padding-bottom: 60px;
}

/*
************
*************************
04. header
******************************************************* 
*************************************************************** */
.bostami-header-wrap {
  background: var(--light-white);
  padding: 20px;
  border-radius: 12px;
}

.bostami-header-menu-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.bostami-header-menu-btn .menu-btn {
  position: relative;
  display: inline-flex;
  width: 26px;
  height: 26px;
  background: linear-gradient(180deg, #fa5252 0%, #e12a72 100%);
  border-radius: 50%;
  text-align: center;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 1s;
  overflow: hidden;
}

.bostami-header-menu-btn .menu-btn:hover {
  background: linear-gradient(180deg, #1b74e4 0%, #1b74e4 100%);
}

.menu-btn span {
  position: absolute;
  width: 12px;
  height: 2px;
  background-color: var(--common-white-two);
  border-radius: 2px;
  transition: 0.5s;
}

.menu-btn span:nth-child(1) {
  transform: translateY(-5px);
}

.menu-btn span:nth-child(2) {
  transform: translateY(5px);
}

.menu-btn.active {
  background: linear-gradient(180deg, #1b74e4 0%, #1b74e4 100%);
}

.menu-btn.active span:nth-child(1) {
  transform: rotate(45deg);
}

.menu-btn.active span:nth-child(2) {
  transform: rotate(-45deg);
}

.menu-btn.active span:nth-child(3) {
  transform: translateX(30px);
}

.mobile-menu-wrap {
  position: relative;
}

.mobile-menu-wrap .mobile-menu {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transform: scaleY(0);
  transform-origin: top;
  z-index: 5;
  transition: 0.5s;
}

.mobile-menu-wrap .mobile-menu .mean-bar {
  background-color: var(--common-white);
  border-radius: 12px;
  box-shadow: 0px 6px 6px rgba(238, 238, 238, 0.2);
  padding-top: 20px;
  padding-bottom: 20px;
}

.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav {
  margin-top: 0;
  background-color: var(--common-white);
}

.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a {
  border: none;
  font-size: 13px;
  text-transform: capitalize;
  font-weight: 500;
  color: var(--body-text);
  padding: 5px 70px;
}

@media (max-width: 767px) {
  .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a {
    padding: 5px 0px;
  }
}
.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a span {
  display: inline-block;
}

.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a span svg {
  width: 16px !important;
  margin-right: 8px;
}

.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a:hover {
  color: var(--theme-secondary);
}

.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a:hover span svg * {
  fill: var(--theme-secondary);
}

@media (max-width: 767px) {
  .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li {
    padding: 0px 40px;
  }
}
.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a {
  color: var(--theme-secondary);
}

.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a span svg * {
  fill: var(--theme-secondary);
}

.mobile-menu.active {
  transform: scaleY(1);
}

.bastami-main-menu ul li {
  background-color: var(--light-white);
  border-radius: 12px;
  width: 84px;
  height: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: 0.3s;
}

.bastami-main-menu ul li:not(:last-child) {
  margin-bottom: 20px;
}

.bastami-main-menu ul li a {
  display: block;
  font-size: 13px;
  text-transform: capitalize;
  font-weight: 500;
  line-height: 1;
}

.bastami-main-menu ul li a span {
  display: block;
  margin-bottom: 12px;
}

.bastami-main-menu ul li:is(.active) {
  background-color: var(--theme-primary);
}

.bastami-main-menu ul li:is(.active) a {
  color: var(--common-white);
}

.bastami-main-menu ul li:is(.active) a span svg * {
  fill: var(--common-white);
}

.bastami-main-menu ul li:is(.active) a span img {
  filter: brightness(5);
}

.bastami-main-menu ul li:hover {
  background-color: var(--theme-primary);
}

.bastami-main-menu ul li:hover a {
  color: var(--common-white);
}

.bastami-main-menu ul li:hover a span svg * {
  fill: var(--common-white);
}

.bastami-main-menu ul li:hover a span img {
  filter: brightness(5);
}

.dark-theme .bastami-main-menu ul li a span img {
  filter: invert(0.8) !important;
}

.dark-theme .bastami-main-menu ul li.active a span img {
  filter: brightness(5) !important;
}

.dark-theme .home-1 .bastami-main-menu ul li:hover a span img,
.dark-theme .home-3 .bastami-main-menu ul li:hover a span img {
  filter: brightness(5) !important;
}

.dark-theme .page-wrapper-2 .bastami-main-menu ul li:hover a span img {
  filter: invert(1) !important;
}

.bastami-main-menu ul li a span img {
  width: 20px;
}

.bastami-main-menu ul li.active:first-child a span img {
  filter: invert(1) !important;
}

.bastami-main-menu ul li:first-child:hover a span img {
  filter: invert(1);
}

.header-right-flex {
  display: flex;
  justify-content: right;
  align-items: center;
}

.main-style-2 {
  background-color: transparent;
}

.main-style-2 .bostami-main-menu-wrap {
  width: unset;
  background: transparent;
  border-radius: 0px;
  padding: 0;
  position: unset;
  top: unset;
  display: inline-block;
}

.main-style-2 .bostami-main-menu-wrap .bastami-main-menu {
  display: inline-block;
}

.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul {
  display: inline-block;
}

.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li {
  display: inline-block;
  background-color: var(--light-white);
  border-radius: 8px;
  width: unset;
  height: unset;
  text-align: unset;
  transition: 0.3s;
  margin-bottom: 0;
}

.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li:not(:first-child) {
  margin-left: 16px;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li:not(:first-child) {
    margin-left: 5px;
  }
}
.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a {
  background: #fff;
  border-radius: 8px;
  padding: 0px 19px;
  transition: 0.3s;
  height: 40px;
  line-height: 40px;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a {
    padding: 0px 10px;
  }
}
.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a:hover {
  background: rgb(250, 82, 82);
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a span {
  display: inline-block;
  margin-bottom: 0;
  margin-right: 5px;
}

.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a span svg {
  width: 20px;
}

.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li:is(.active) a {
  background: rgb(250, 82, 82);
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.bostami-header-logo {
  flex: 0 0 auto;
}

.menu-btn.menu-btn-2 {
  width: 45px;
  height: 45px;
  margin-left: 20px;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .menu-btn.menu-btn-2 {
    margin-bottom: -8px;
  }
}
.page-wrapper.page-wrapper-2 .bostami-header-logo .site-logo img {
  width: 150px;
}

@media (max-width: 767px) {
  .page-wrapper.page-wrapper-2 .bostami-header-logo .site-logo img {
    width: 110px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .page-wrapper.page-wrapper-2 .bostami-header-logo .site-logo img {
    width: 150px;
  }
}
.dark-theme .page-wrapper.page-wrapper-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.home-3 .text-right {
  text-align: right;
  margin-bottom: 40px;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .home-3 .text-right {
    margin-bottom: 0;
  }
}
.home-3 .bostami-main-menu-wrap {
  width: unset;
  position: unset;
  display: inline-block;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .home-3 .bostami-main-menu-wrap {
    display: none;
  }
}
.home-3 .bastami-main-menu ul li {
  display: inline-flex;
  margin-bottom: 0;
}

.home-3 .bastami-main-menu ul li:not(:first-child) {
  margin-left: 16px;
}

.home-3 .bastami-main-menu ul li:hover {
  /* background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%); */
  background-color: var(--theme-primary);
}

.home-3 .bastami-main-menu ul li:is(.active) {
  /* background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%); */
  background-color: var(--theme-primary);
}

.inner-page .bostami-header-wrap {
  padding: 20px 0;
}

.home-3 .bostami-header-menu-btn .menu-btn {
  width: 40px;
  height: 40px;
}

.home-3 .menu-btn.active {
  /* background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%); */
  background-color: var(--theme-primary);
}

.home-1 .bostami-header-area {
  margin-bottom: 205px;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .home-1 .bostami-header-area {
    margin-bottom: 50px;
  }
}
.home-1 .bostami-header-wrap {
  margin-left: -112px;
  margin-right: -70px;
  background-color: transparent;
}

@media only screen and (min-width: 1400px) and (max-width: 1599px) {
  .home-1 .bostami-header-wrap {
    margin-left: -50px;
    margin-right: -40px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .home-1 .bostami-header-wrap {
    margin-left: 0px;
    margin-right: 0px;
  }
}
.home-1 .bostami-header-menu-btn .menu-btn {
  width: 40px;
  height: 40px;
}

@media (min-width: 1800px), only screen and (min-width: 1600px) and (max-width: 1799px), only screen and (min-width: 1400px) and (max-width: 1599px) {
  .home-1 .bostami-header-menu-btn .menu-btn {
    display: none;
  }
}
.home-1 .bostami-header-menu-btn .menu-btn {
  background: #1b74e4;
}

.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a {
  color: #1b74e4;
}

.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:hover a {
  color: #1b74e4;
}

.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:hover a span img {
  filter: saturate(20.5);
}

.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a span img {
  filter: saturate(20.5);
}

.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a:hover span svg * {
  fill: #1b74e4;
}

.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a span svg * {
  fill: #1b74e4;
}

/*
************
*************************
05. parsonal info
******************************************************* 
*************************************************************** */
.bostami-parsonal-info-area {
  width: 400px;
  border-radius: 20px;
  background-color: var(--common-white);
  text-align: center;
  padding: 40px 30px;
  margin-left: -100px;
  position: sticky;
  top: 100px;
}

@media only screen and (min-width: 1400px) and (max-width: 1599px) {
  .bostami-parsonal-info-area {
    width: 340px;
    margin-left: -40px;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .bostami-parsonal-info-area {
    width: 100%;
    margin-left: 0px;
    padding: 30px 15px;
    top: -40px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px) {
  .bostami-parsonal-info-area {
    width: 100%;
    margin-left: 0px;
    margin-bottom: 30px;
    top: -40px;
  }
}
@media (max-width: 767px) {
  .bostami-parsonal-info-area {
    width: 100%;
    margin-left: 0px;
    margin-bottom: 30px;
    padding: 40px 20px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .bostami-parsonal-info-area {
    padding: 40px 30px;
  }
}
.bostami-parsonal-info-img {
  width: 240px;
  height: 240px;
  border-radius: 20px;
  overflow: hidden;
  margin: auto;
  margin-bottom: 21px;
  margin-top: -180px;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .bostami-parsonal-info-img {
    width: 210px;
    height: 210px;
    margin-top: 0px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px), only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .bostami-parsonal-info-img {
    margin-top: 0px;
  }
}
.bostami-parsonal-info-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bostami-parsonal-info-name {
  font-size: 26px;
  text-transform: capitalize;
  font-weight: 500;
  color: var(--common-black);
  font-family: "Roboto Slab", serif;
  margin-bottom: 8px;
}

.btn-2.circle {
  border-radius: 30px;
}

.dark-theme .btn-2.circle {
  color: #fff;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .bostami-parsonal-info-name {
    font-size: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .bostami-parsonal-info-name {
    font-size: 22px;
  }
}
.bostami-parsonal-info-bio {
  font-size: 14px;
  display: inline-block;
  font-weight: 500;
  text-transform: capitalize;
  color: var(--common-black);
  font-family: "Poppins", sans-serif;
  background-color: var(--light-white);
  border-radius: 5px;
  padding: 4px 20px;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px), only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .bostami-parsonal-info-bio {
    font-size: 14px;
  }
}
.bostami-parsonal-info-social-link li {
  display: inline-block;
  margin: 0 4px;
}

.bostami-parsonal-info-social-link li a {
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: var(--light-white);
  text-align: center;
  line-height: 40px;
}

.bostami-parsonal-info-social-link li a:hover {
  background-color: var(--theme-primary);
}

.bostami-parsonal-info-social-link li a:hover {
  color: var(--common-white-two) !important;
}

.bostami-parsonal-info-social-link li a {
  color: #1c9cea;
  font-size: 20px;
}

.bostami-parsonal-info-contact {
  background-color: var(--light-white);
  border-radius: 16px;
  text-align: left;
  padding: 20px 30px;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .bostami-parsonal-info-contact {
    padding: 20px 15px;
  }
}
@media (max-width: 767px) {
  .bostami-parsonal-info-contact {
    padding: 20px 15px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .bostami-parsonal-info-contact {
    padding: 20px 30px;
  }
}
.bostami-parsonal-info-contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.bostami-parsonal-info-contact-item:not(:first-child) {
  border-top: 1px solid #e3e3e3;
}

.bostami-parsonal-info-contact-item .icon {
  flex: 0 0 auto;
  display: inline-block;
  width: 44px;
  height: 44px;
  background-color: var(--common-white);
  border-radius: 8px;
  text-align: center;
  line-height: 44px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);
  transition: 0.3s;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .bostami-parsonal-info-contact-item .icon {
    width: 35px;
    height: 35px;
    line-height: 35px;
    transition: 0.3s;
  }
}
.bostami-parsonal-info-contact-item .icon svg * {
  transition: 0.3s;
}

.bostami-parsonal-info-contact-item .icon:hover {
  background-color: var(--theme-primary);
  color: var(--common-white-two) !important;
}

.bostami-parsonal-info-contact-item .text {
  display: inline-block;
}

.bostami-parsonal-info-contact-item .text span {
  display: block;
  font-size: 12px;
  line-height: 18px;
  text-transform: capitalize;
  font-weight: 400;
  margin-bottom: 3px;
}

.bostami-parsonal-info-contact-item .text p {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: var(--common-black);
  text-transform: capitalize;
  margin-bottom: 0;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .bostami-parsonal-info-contact-item .text p {
    font-size: 14px;
  }
}
.bostami-parsonal-info-area.bostami-parsonal-info-2-area {
  background-color: transparent;
  width: unset;
  margin-left: 0;
  position: unset;
}

@media (min-width: 1920px) {
  .bostami-parsonal-info-area.bostami-parsonal-info-2-area {
    margin-top: 50px;
  }
}
.bostami-parsonal-info-area.bostami-parsonal-info-2-area .bostami-parsonal-info-img {
  width: 280px;
  height: 280px;
  border-radius: 50%;
  overflow: hidden;
  margin: auto;
  margin-bottom: 21px;
  margin-top: 0;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .bostami-parsonal-info-area.bostami-parsonal-info-2-area .bostami-parsonal-info-img {
    width: 240px;
    height: 240px;
  }
}
.bostami-parsonal-info-area.bostami-parsonal-info-2-area .bostami-parsonal-info-bio {
  background: transparent;
  color: #7b7b7b;
}

.bostami-parsonal-info-area.bostami-parsonal-info-2-area .bostami-parsonal-info-social-link li a:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.bostami-parsonal-info-area.about-2-page {
  width: 100%;
  margin-left: 0;
  background: transparent;
  position: unset;
  padding: 0;
}

.bostami-parsonal-info-area.about-2-page .bostami-page-title-wrap {
  text-align: left;
}

.bostami-parsonal-info-area.about-2-page .bostami-parsonal-info-img {
  width: 100%;
  height: 400px;
  margin-bottom: 0;
  margin-top: 0;
}

.page-wrapper-2 .bostami-parsonal-info-contact-item .icon:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.home-3 .bostami-parsonal-info-area {
  width: 100%;
  margin-left: 0;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .home-3 .bostami-parsonal-info-contact {
    padding: 20px 10px;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .home-3 .bostami-parsonal-info-contact-item .text p {
    font-size: 14px;
  }
}
.home-3 .bostami-parsonal-info-social-link li a:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.home-3 .bostami-parsonal-info-contact-item .icon:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

/*
************
*************************
06. client
******************************************************* 
*************************************************************** */
.bostami-client {
  padding-top: 40px;
  padding-bottom: 70px;
  background-color: var(--light-white-2);
}

.bostami-client-slider-logo {
  padding: 0px 15px;
  height: 62px;
}

.bostami-main-menu-wrap {
  width: 144px;
  background: white;
  border-radius: 16px;
  padding: 30px;
  position: sticky;
  top: -45px;
}

@media only screen and (min-width: 1400px) and (max-width: 1599px) {
  .bostami-main-menu-wrap {
    width: 120px;
    padding: 18px;
  }
}
.bostami-client-slider .swiper-slide {
  text-align: center !important;
}

/*
************
*************************
07. what do
******************************************************* 
*************************************************************** */
.bostami-what-do-item {
  border-radius: 12px;
  display: flex;
  gap: 20px;
  padding: 20px;
  padding-bottom: 15px;
  margin-bottom: 30px;
}

@media (max-width: 767px) {
  .bostami-what-do-item {
    flex-wrap: wrap;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .bostami-what-do-item {
    flex-wrap: nowrap;
  }
}
.bostami-what-do-item .text .title {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 500;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px), lg, only screen and (min-width: 768px) and (max-width: 991px) {
  .bostami-what-do-item .text .title {
    font-size: 22px;
  }
}
@media (max-width: 767px) {
  .bostami-what-do-item .text .title {
    font-size: 22px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .bostami-what-do-item .text .title {
    font-size: 24px;
  }
}
.bostami-what-do-item .text p {
  margin-bottom: 0;
  line-height: 30px;
}

.bostami-page-wrap .client-2-wrap {
  border-radius: 20px;
  padding-left: 25px;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .page-wrapper-2 .bostami-what-do-item {
    flex-wrap: wrap;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .home-3 .bostami-what-do-item {
    flex-wrap: wrap;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .home-3 .bostami-what-do-item .text .title {
    font-size: 20px;
  }
}
/*
************
*************************
08. resume
******************************************************* 
*************************************************************** */
@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .bostami-card-wrap {
    margin-bottom: 50px;
  }
}
.bostami-card-item {
  padding: 20px;
  border-radius: 12px;
  padding-top: 25px;
}

.bostami-card-item .card-subtitle {
  display: block;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  margin-bottom: 9px;
}

.bostami-card-item .card-title {
  font-size: 18px;
  font-weight: 400;
  color: var(--heading-black);
  margin-bottom: 4px;
}

.bostami-card-item .card-title span {
  color: var(--body-text);
}

.bostami-card-item .card-text {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
}

.skill-bar-item .title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
}

.skill-bar-item .title-wrap .title {
  font-size: 16px;
  font-weight: 400;
  color: var(--body-text);
  margin-bottom: 0;
}

.skill-bar-item .title-wrap .count {
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: var(--body-text);
}

.skill-section {
  background-color: var(--light-white-2);
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .skill-bar-wrap {
    margin-bottom: 50px;
  }
}
.progress-bar-wrap {
  height: 6px;
  background: #edf2f2;
  border-radius: 6px;
  overflow: inherit;
}

.progress-line {
  height: 100%;
  border-radius: inherit;
}

.progress-bg-1 {
  background-color: #ff6464;
}

.progress-bg-2 {
  background-color: #9272d4;
}

.progress-bg-3 {
  background-color: #5185d4;
}

.progress-bg-4 {
  background-color: #ca56f2;
}

.knowledeges-item-wrap .gk-item {
  display: inline-block;
  font-size: 15px;
  font-weight: 400;
  background: #edf2f2;
  border-radius: 8px;
  padding: 5px 20px;
  margin-right: 10px;
  margin-bottom: 20px;
}

@media (max-width: 767px) {
  .bostami-resume-page {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .bostami-resume-page {
    padding-left: 60px;
    padding-right: 60px;
  }
}
@media (max-width: 767px) {
  .section-wrap {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .section-wrap {
    padding-left: 60px;
    padding-right: 60px;
  }
}
.page-wrapper-2 .border-redius-20 {
  border-radius: 20px;
}

/*
************
*************************
09. portfolio
******************************************************* 
*************************************************************** */
.fillter-btn-wrap {
  text-align: right;
}

@media (max-width: 767px) {
  .fillter-btn-wrap {
    text-align: left;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .fillter-btn-wrap {
    text-align: right;
  }
}
.fillter-btn-wrap .fillter-btn {
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  display: inline-block;
  padding: 0 18px;
  cursor: pointer;
}

.fillter-btn-wrap .fillter-btn:hover {
  color: var(--theme-primary);
}

.fillter-btn-wrap .fillter-btn:is(.is-checked) {
  color: var(--theme-primary);
}

.fillter-item {
  display: inline-block;
  border-radius: 12px;
  padding: 20px;
}

.fillter-item .img {
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 17px;
  display: block;
  transition: 0.1s;
}

.fillter-item:hover img {
  transform: scale(1.1);
}

.fillter-item .item-subtitle {
  display: block;
  font-size: 12px;
  font-weight: 400;
  text-transform: capitalize;
}

.fillter-item .item-title {
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  margin-bottom: 0;
}

.fillter-item .item-title:hover {
  color: var(--theme-primary);
}

.isotop-item,
.grid-sizer {
  width: 50%;
  padding: 0 10px;
}

@media (max-width: 767px) {
  .isotop-item,
  .grid-sizer {
    width: 100%;
  }
}
.isotop-item > div,
.isotop-item > div {
  margin-bottom: 20px;
}

.portfolio-modal-box {
  position: fixed;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4509803922);
}

.portfolio-modal-box .modal-dialog {
  max-width: 850px;
  height: 90vh;
  overflow: hidden;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  border: none;
  /* width */
  /* Track */
  /* Handle */
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .portfolio-modal-box .modal-dialog {
    max-width: 660px;
  }
}
@media (max-width: 767px) {
  .portfolio-modal-box .modal-dialog {
    max-width: 95%;
    padding: 10px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .portfolio-modal-box .modal-dialog {
    max-width: 95%;
    padding: 30px;
  }
}
.portfolio-modal-box .modal-dialog ::-webkit-scrollbar {
  width: 10px;
}

.portfolio-modal-box .modal-dialog ::-webkit-scrollbar-track {
  background-color: #e9e3e3;
  border-radius: 10px;
}

.portfolio-modal-box .modal-dialog ::-webkit-scrollbar-thumb {
  background: #9c9fa1;
  border-radius: 10px;
}

.portfolio-modal-box .modal-dialog .modal-content {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
  position: relative;
  padding-right: 15px;
  border-radius: 0;
  border: none;
}

.portfolio-modal-box .modal-dialog .modal-content .modal-header {
  display: inline-block;
  position: fixed;
  right: 25%;
  top: 5%;
  z-index: 18;
  border-bottom: 0;
  padding: 0;
}

@media (min-width: 1800px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-header {
    right: 25%;
    top: 3%;
  }
}
@media only screen and (min-width: 1600px) and (max-width: 1799px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-header {
    right: 18%;
    top: 8%;
  }
}
@media only screen and (min-width: 1400px) and (max-width: 1599px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-header {
    right: 19%;
    top: 4%;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-header {
    right: 8%;
    top: 10%;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-header {
    right: 3%;
    top: 2%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-header {
    right: 1%;
    top: 3%;
  }
}
@media (max-width: 767px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-header {
    right: 1%;
    top: 4%;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-header {
    right: 1%;
    top: 4%;
  }
}
.portfolio-modal-box .modal-dialog .modal-content .modal-header .close {
  background: transparent;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  color: white;
  border-color: white;
  border: 1px solid;
  line-height: 38px;
  transition: 0.3s;
}

@media (max-width: 767px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-header .close {
    border-color: #e12a72;
    color: #e12a72;
  }
}
.portfolio-modal-box .modal-dialog .modal-content .modal-header .close:hover {
  rotate: 90deg;
  border-color: #e12a72;
  color: #e12a72;
}

.portfolio-modal-box .modal-dialog .modal-content .modal-body .h1-modal-img {
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 20px;
}

.portfolio-modal-box .modal-dialog .modal-content .modal-body .blog-title {
  font-size: 28px;
  text-align: center;
  color: #fa5252;
  margin-bottom: 35px;
}

@media (max-width: 767px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-body .blog-title {
    margin-top: 20px;
    font-size: 22px;
  }
}
.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table {
  margin-bottom: 20px;
}

.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text {
  font-size: 18px;
  font-weight: 400;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text {
    font-size: 15px;
  }
}
@media (max-width: 767px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text {
    font-size: 14px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text {
    font-size: 16px;
  }
}
.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text i {
  display: inline-block;
  margin-right: 10px;
}

.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text span {
  font-weight: 500;
}

.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text a {
  display: inline-block;
  font-weight: 500;
}

.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text a:hover {
  color: #fa5252;
}

.portfolio-modal-box .modal-dialog .modal-content .modal-body .h1-modal-paragraph {
  margin-bottom: 30px;
}

.page-wrapper-2 .isotop-item,
.page-wrapper-2 .grid-sizer {
  width: 33.33%;
  padding: 0 10px;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .page-wrapper-2 .isotop-item,
  .page-wrapper-2 .grid-sizer {
    width: 33.33%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .page-wrapper-2 .isotop-item,
  .page-wrapper-2 .grid-sizer {
    width: 50%;
  }
}
@media (max-width: 767px) {
  .page-wrapper-2 .isotop-item,
  .page-wrapper-2 .grid-sizer {
    width: 100%;
  }
}
.page-wrapper-2 .fillter-btn-wrap .fillter-btn:hover {
  color: #fa5252;
}

.page-wrapper-2 .fillter-btn-wrap .fillter-btn.is-checked {
  color: #fa5252;
}

.page-wrapper-2 .fillter-item .item-title:hover {
  color: #fa5252;
}

.home-3 .fillter-btn-wrap .fillter-btn:is(.is-checked) {
  color: #fa5252;
}

.home-3 .fillter-btn-wrap .fillter-btn:hover {
  color: #fa5252;
}

.home-3 .fillter-item .item-title:hover {
  color: #fa5252;
}

/*
************
*************************
10. blog
******************************************************* 
*************************************************************** */
.blog-slider-single {
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
}

.blog-slider-single .img {
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 18px;
  display: block;
}

.blog-slider-single .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.blog-slider-single:hover img {
  transform: scale(1.1);
}

.blog-slider-single .blog-meta span {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  margin-right: 5px;
}

.blog-slider-single .blog-meta .blog-cetagory {
  position: relative;
  padding-left: 12px;
}

.blog-slider-single .blog-meta .blog-cetagory::after {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: var(--body-text);
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.blog-slider-single .blog-title {
  font-size: 18px;
  font-weight: 500;
  text-transform: capitalize;
}

.blog-slider-single .blog-title:hover {
  color: var(--theme-primary);
}

.blog-slider-wrap .blog-progation {
  text-align: center;
}

.blog-slider-wrap .blog-progation span {
  width: 12px;
  height: 12px;
  background-color: transparent;
  border: 1px solid var(--theme-primary) !important;
  margin: 0px 5px !important;
  opacity: 1;
}

.blog-slider-wrap .blog-progation span:is(.swiper-pagination-bullet-active) {
  background-color: var(--theme-primary);
}

.h1-modal-box {
  position: fixed;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4509803922);
}

.h1-modal-box .modal-dialog {
  max-width: 850px;
  height: 90vh;
  overflow: hidden;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  border: none;
  /* width */
  /* Track */
  /* Handle */
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .h1-modal-box .modal-dialog {
    max-width: 660px;
  }
}
@media (max-width: 767px) {
  .h1-modal-box .modal-dialog {
    max-width: 95%;
    padding: 10px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .h1-modal-box .modal-dialog {
    max-width: 95%;
    padding: 30px;
  }
}
.h1-modal-box .modal-dialog ::-webkit-scrollbar {
  width: 10px;
}

.h1-modal-box .modal-dialog ::-webkit-scrollbar-track {
  background-color: #e9e3e3;
  border-radius: 10px;
}

.h1-modal-box .modal-dialog ::-webkit-scrollbar-thumb {
  background: #9c9fa1;
  border-radius: 10px;
}

.h1-modal-box .modal-dialog .modal-content {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
  position: relative;
  padding-right: 15px;
  border-radius: 0;
  border: none;
}

.modal-header {
  display: inline-block;
  position: fixed;
  right: 25%;
  top: 3%;
  z-index: 18;
  border-bottom: 0;
  padding: 0;
}

@media (min-width: 1800px) {
  .modal-header {
    right: 25%;
    top: 3%;
  }
}
@media only screen and (min-width: 1600px) and (max-width: 1799px) {
  .modal-header {
    right: 18%;
    top: 8%;
  }
}
@media only screen and (min-width: 1400px) and (max-width: 1599px) {
  .modal-header {
    right: 18%;
    top: 5%;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .modal-header {
    right: 8%;
    top: 10%;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .modal-header {
    right: 4%;
    top: 5%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .modal-header {
    right: 10%;
    top: 5%;
  }
}
@media (max-width: 767px) {
  .modal-header {
    right: 3%;
    top: 1%;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .modal-header {
    right: 3%;
    top: 1%;
  }
}
.modal-header .close {
  background: transparent;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  color: white;
  border-color: white;
  border: 2px solid;
  line-height: 38px;
  transition: 0.3s;
}

@media (max-width: 767px) {
  .modal-header .close {
    border-color: #e12a72;
    color: #e12a72;
  }
}
.modal-header .close:hover {
  rotate: 90deg;
  border-color: #e12a72;
  color: #e12a72;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-img {
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 20px;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .blog-meta {
  margin-bottom: 15px;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .blog-meta .blog-date,
.h1-modal-box .modal-dialog .modal-content .modal-body .blog-meta .blog-cetagory {
  font-size: 18px;
  margin-right: 15px;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .blog-title {
  font-size: 24px;
  font-weight: 600;
}

@media (max-width: 767px) {
  .h1-modal-box .modal-dialog .modal-content .modal-body .blog-title {
    font-size: 22px;
  }
}
.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item {
  display: flex;
  gap: 30px;
  border: 1px solid #fa5252;
  border-radius: 15px;
  padding: 20px;
  margin-top: 50px;
  margin-bottom: 30px;
}

@media (max-width: 767px) {
  .h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item {
    flex-wrap: wrap;
    gap: 15px;
  }
}
.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .img {
  width: 125px;
  height: 122px;
  flex: 0 0 auto;
  overflow: hidden;
  border-radius: 15px;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .name-date {
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .name-date .name {
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 0;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .name-date .date {
  font-size: 14px;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .comment-text {
  margin-bottom: 5px;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .reply-btn {
  transition: 0.3s;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .reply-btn:hover {
  color: #fa5252;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box .title {
  font-size: 26px;
  font-weight: 500;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box textarea {
  width: 100%;
  height: 80px;
  border: none;
  background: #f3f6f6;
  border-radius: 5px;
  margin-bottom: 20px;
  padding: 15px;
  font-size: 12px;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box textarea::placeholder {
  font-size: 12px;
  color: #9c9fa1;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box button {
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
  border: none;
  outline: none;
  padding: 8px 20px;
  border-radius: 20px;
  background: linear-gradient(180deg, #fa5252 0%, #e12a72 100%);
  color: white;
}

.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box button:hover {
  background: linear-gradient(80deg, #fa5252 0%, #e12a72 100%);
}

.page-wrapper-2 .blog-slider-wrap .blog-progation span {
  border: 1px solid #fa5252 !important;
}

.page-wrapper-2 .blog-slider-wrap .blog-progation span:is(.swiper-pagination-bullet-active) {
  background-color: #fa5252;
}

.page-wrapper-2 .blog-slider-single .blog-title:hover {
  color: #fa5252;
}

.home-3 .blog-slider-wrap .blog-progation span {
  border: 1px solid #f95054 !important;
}

.home-3 .blog-slider-wrap .blog-progation span:is(.swiper-pagination-bullet-active) {
  background-color: #f95054;
}

.home-3 .blog-slider-single .blog-title:hover {
  color: #fa5252;
}

/*
************
*************************
11. contact
******************************************************* 
*************************************************************** */
.contact-area {
  padding: 40px 45px;
  border-radius: 20px;
}

@media (max-width: 767px) {
  .contact-area {
    padding: 60px 20px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .contact-area {
    padding: 60px 30px;
  }
}
.contact-area .contact-title {
  font-size: 25px;
  font-weight: 400;
  color: var(--body-text);
  text-transform: capitalize;
  margin-bottom: 13px;
}

.contact-area .contact-title-b {
  font-size: 25px;
  font-weight: 700;
  text-transform: lowercase;
  margin-bottom: 45px;
}

.contact-form .input-lebel {
  font-size: 16px;
  display: inline-block;
  font-weight: 500;
  text-transform: capitalize;
  line-height: 1;
}

.contact-form .input-box {
  display: block;
  width: 100%;
  border: none;
  outline: none;
  border-bottom: 1px solid #b5b5b5;
  background: transparent;
  height: 15px;
  transition: 0.3s;
  transform-origin: top;
  font-size: 14px;
}

.contact-form .input-box:is(.height) {
  height: 40px;
}

.bostami-contact-item {
  display: flex;
  gap: 20px;
  padding: 30px;
  border-radius: 10px;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .bostami-contact-item {
    padding: 20px;
  }
}
@media (max-width: 767px) {
  .bostami-contact-item {
    padding: 20px;
    flex-wrap: wrap;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .bostami-contact-item {
    padding: 30px;
    flex-wrap: nowrap;
  }
}
.bostami-contact-item .icon {
  flex: 0 0 auto;
  width: 35px;
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .bostami-contact-item .icon {
    width: 40px;
  }
}
@media (max-width: 767px) {
  .bostami-contact-item .icon {
    width: 40px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .bostami-contact-item .icon {
    width: 80px;
  }
}
.bostami-contact-item .text .title {
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  margin-bottom: 10px;
}

.bostami-contact-item .text span {
  display: block;
  font-size: 18px;
  font-weight: 400;
  color: #44566c;
  line-height: 30px;
}

/*
************
*************************
12. preloader
******************************************************* 
*************************************************************** */
/* preloader */
#preloader {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100%;
  z-index: 1000000000000000000;
  display: flex;
}

#preloader:before,
#preloader:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 50%;
  height: 100%;
  z-index: -1;
  background-color: #000;
  transition: all 0.3s ease 0s;
}

#preloader:after {
  left: auto;
  right: 0;
}

#preloader .loader_line {
  margin: auto;
  width: 1px;
  height: 250px;
  position: relative;
  overflow: hidden;
  transition: all 0.8s ease 0s;
}

.loader_line:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 1px;
  height: 0%;
  transform: translateY(-50%);
  background-color: #fff;
  animation: lineheight 1000ms ease-in-out 0s forwards;
}

.loader_line:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  height: 100%;
  background-color: #999999;
  transform: translateY(-100%);
  animation: lineround 1200ms linear 0s infinite;
  animation-delay: 2000ms;
}

@keyframes lineheight {
  0% {
    height: 0%;
  }
  100% {
    height: 100%;
  }
}
@keyframes lineround {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(200%);
  }
}
.portfolio_list {
  min-height: 50vh;
}

/*hiding all*/
.preloaded .loader_line:after {
  opacity: 0;
}

.preloaded .loader_line {
  opacity: 0;
  height: 100% !important;
}

.preloaded:before,
.preloaded:after {
  animation: preloadedzero 300ms ease-in-out 500ms forwards;
}

@keyframes preloadedzero {
  0% {
    width: 50%;
  }
  100% {
    width: 0%;
  }
}
/*
************
*************************
13. blog details
******************************************************* 
*************************************************************** */
.blog-details-area {
  background-color: #fff;
}

.breadcrumb-title {
  font-size: 30px;
  font-weight: 400;
  text-transform: capitalize;
  color: #000;
  line-height: 1.33;
  font-family: "Roboto Slab", serif;
  margin-bottom: 15px;
}

@media (max-width: 767px) {
  .breadcrumb-title {
    font-size: 26px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .breadcrumb-title {
    font-size: 30px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .breadcrumb-title br {
    display: none;
  }
}
.breadcrumb-meta-wrap .meta-item {
  display: inline-block;
  position: relative;
  padding: 0 10px;
}

.breadcrumb-meta-wrap .meta-item:not(:last-child)::after {
  position: absolute;
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #696969;
  top: 42%;
  right: -4px;
}

.breadcrumb-meta-wrap .meta-item .img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.breadcrumb-meta-wrap .meta-item .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.breadcrumb-meta-wrap .meta-item .author-name,
.breadcrumb-meta-wrap .meta-item .date,
.breadcrumb-meta-wrap .meta-item .comment {
  display: inline-block;
  font-size: 14px;
  line-height: 21px;
  text-transform: capitalize;
  color: #44566c;
}

.blog-details-inner-title {
  font-size: 18px;
  font-weight: 500;
  color: #202124;
}

.blog-details-content p {
  font-size: 15px;
  line-height: 30px;
  color: #77838f;
}

.blog-details-blockquote {
  font-size: 15px;
  font-weight: 400;
  font-style: italic;
  color: #202124;
  line-height: 30px;
  padding: 40px 58px;
  background-color: #f3f6f6;
}

@media (max-width: 767px) {
  .blog-details-blockquote {
    padding: 30px 20px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .blog-details-blockquote {
    padding: 40px 58px;
  }
}
.blog-details-blockquote span {
  display: block;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #696969;
  margin-top: 10px;
}

.blog-details-list-item-wrap li {
  font-size: 15px;
  line-height: 46px;
  font-weight: 400;
  color: #696969;
}

.blog-details-list-item-wrap li i {
  display: inline-block;
  font-size: 18px;
  margin-right: 7px;
}

.blog-details-short-list li {
  font-size: 15px;
  font-weight: 400;
  line-height: 46px;
  color: #696969;
  position: relative;
  padding-left: 19px;
}

.blog-details-short-list li::after {
  position: absolute;
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #696969;
  top: 20px;
  left: 0;
}

.blog-details-tag {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  padding: 20px 0;
  border-top: 1px solid #ecedf2;
  border-bottom: 1px solid #ecedf2;
}

.blog-details-tag .title {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000;
  text-transform: capitalize;
  margin-bottom: 0;
}

.blog-details-tag .tag-item a {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-transform: capitalize;
  color: #696969;
  background: #f0f5f7;
  border-radius: 4px;
  padding: 7px 20px;
  transition: 0.3s;
}

@media (max-width: 767px) {
  .blog-details-tag .tag-item a {
    margin-bottom: 8px;
  }
}
.blog-details-tag .tag-item a:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
  color: #fff;
}

.blog-details-comment-item .ratting {
  text-align: right;
}

.blog-details-comment-item .ratting i {
  display: inline-block;
  font-size: 13px;
  color: #ffc78b;
}

.blog-details-comment-item .flex {
  display: flex;
  gap: 32px;
}

.blog-details-comment-item .flex .img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  flex: 0 0 auto;
}

.blog-details-comment-item .flex .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.blog-details-comment-item .flex .content .name {
  display: block;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #202124;
  text-transform: capitalize;
}

.blog-details-comment-item .flex .content .bio {
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  line-height: 21px;
  color: #696969;
  margin-bottom: 18px;
}

.blog-details-comment-item .flex .content p {
  font-weight: 400;
  font-size: 15px;
  line-height: 26px;
  color: #696969;
  margin-bottom: 0;
}

.blog-details-comment-box {
  padding: 50px;
  border: 1px solid #ecedf2;
  border-radius: 8px;
}

@media (max-width: 767px) {
  .blog-details-comment-box {
    padding: 25px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .blog-details-comment-box {
    padding: 50px;
  }
}
.blog-details-comment-box .blog-details-inner-title {
  margin-bottom: 0;
}

.blog-details-comment-box .ratting i {
  display: inline-block;
  font-size: 13px;
  color: #ffc78b;
}

.blog-details-comment-box form .input-title {
  text-transform: capitalize;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: #202124;
  display: block;
  margin-bottom: 3px;
}

.blog-details-comment-box form input,
.blog-details-comment-box form textarea {
  display: block;
  width: 100%;
  border: none;
  background: #f0f5f7;
  border-radius: 8px;
  height: 60px;
  font-size: 14px;
  font-weight: 400;
  color: #77838f;
  padding: 22px;
}

.blog-details-comment-box form input::placeholder,
.blog-details-comment-box form textarea::placeholder {
  font-size: 14px;
  font-weight: 400;
  color: #77838f;
  text-transform: capitalize;
}

.blog-details-comment-box form textarea {
  height: 195px;
  padding: 19px 25px;
}

.blog-details-comment-box form .submit-comments {
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  text-transform: capitalize;
  color: #1a1a1a;
  background: #f8fbfb;
  border: 2px solid #44566c;
  border-radius: 12px;
  padding: 12px 34px;
  transition: 0.3s;
}

.blog-details-comment-box form .submit-comments:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
  color: #fff;
  border-color: transparent;
}

/*
************
*************************
14. sidebar
******************************************************* 
*************************************************************** */
.sidebar-wrap {
  padding: 30px;
  background: #f3f6f6;
  border-radius: 8px;
  margin-left: 20px;
}

@media only screen and (min-width: 768px) and (max-width: 991px), (max-width: 767px) {
  .sidebar-wrap {
    margin-left: 0;
    margin-top: 50px;
  }
}
.sidebar-box-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  color: #202124;
  text-transform: capitalize;
  margin-bottom: 10px;
}

.sidebar-search-box {
  position: relative;
}

.sidebar-search-box .search-btn {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 23px;
  background: transparent;
  border: 0;
  padding: 0;
  font-size: 18px;
  color: #696969;
}

.sidebar-search-box .search-input {
  width: 100%;
  height: 60px;
  background: #ffffff;
  border: 1px solid #ecedf2;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  color: #696969;
  padding: 22px;
  padding-left: 55px;
}

.sidebar-search-box .search-input::placeholder {
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  color: #696969;
  text-transform: capitalize;
}

.sidebar-category li a {
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  color: #696969;
  text-transform: capitalize;
  position: relative;
  padding-left: 15px;
  transition: 0.3s;
}

.sidebar-category li a::after {
  position: absolute;
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #202124;
  top: 8px;
  left: 0;
  transition: 0.3s;
}

.sidebar-category li a:hover {
  color: #dd2476;
}

.sidebar-category li a:hover::after {
  background-color: #dd2476;
}

.recent-post-item {
  display: flex;
  align-items: center;
  gap: 22px;
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .recent-post-item {
    gap: 10px;
  }
}
.recent-post-item .img {
  flex: 0 0 auto;
  width: 70px;
  height: 70px;
  border-radius: 6px;
  overflow: hidden;
}

.recent-post-item .img a img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recent-post-item .content .date {
  display: block;
  font-weight: 400;
  font-size: 14px;
  text-transform: capitalize;
  color: #696969;
  line-height: 21px;
}

.recent-post-item .content .title {
  font-size: 15px;
  font-weight: 400;
  text-transform: capitalize;
  line-height: 22px;
  color: #202124;
  margin-bottom: 3px;
}

.recent-post-item .content .title a {
  text-decoration: none;
}

.recent-post-item .content .title:hover {
  color: #dd2476;
}

.sidebar-tag a {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #696969;
  background: #fff;
  padding: 5px 20px;
  border-radius: 4px;
  margin-right: 7px;
  margin-bottom: 7px;
  transition: 0.3s;
}

.sidebar-tag a:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
  color: #fff;
}

/*
************
*************************
15. dark theme
******************************************************* 
*************************************************************** */
.dark-theme .overly {
  position: fixed;
  left: 0;
  top: 0;
  background: #000;
  opacity: 0.5;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
}

.dark-theme .page-wrapper .bostami-header-wrap,
.dark-theme .page-wrapper .bostami-parsonal-info-area,
.dark-theme .page-wrapper .bostami-main-menu-wrap {
  background-color: #000;
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar,
.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav,
.dark-theme .page-wrapper .bostami-parsonal-info-contact,
.dark-theme .page-wrapper .bostami-parsonal-info-bio,
.dark-theme .page-wrapper .bostami-parsonal-info-social-link li a,
.dark-theme .page-wrapper .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a {
  background-color: #1d1d1d;
}

.dark-theme .page-wrapper .bg-light-white-2,
.dark-theme .page-wrapper .blog-slider-single,
.dark-theme .page-wrapper .fillter-item {
  background-color: #0d0d0d;
}

.dark-theme .page-wrapper .knowledeges-item-wrap .gk-item {
  background-color: #1c1c1c;
}

.dark-theme .page-wrapper .bastami-main-menu ul li,
.dark-theme .page-wrapper .bostami-contact-item {
  background-color: #212425;
}

.dark-theme .page-wrapper .bastami-main-menu ul li.active a {
  color: #fff;
}

.dark-theme .page-wrapper .bastami-main-menu ul li.active {
  background-color: #1b74e4;
}

.dark-theme .page-wrapper .bastami-main-menu ul li:hover a {
  color: #fff;
}

.dark-theme .page-wrapper .bastami-main-menu ul li:hover {
  background-color: #1b74e4;
}

.dark-theme .page-wrapper .bostami-what-do-item,
.dark-theme .page-wrapper .bostami-card-item,
.dark-theme .page-wrapper .form-btn,
.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a {
  background-color: transparent;
}

.dark-theme .page-wrapper .bostami-parsonal-info-social-link li a:hover {
  background-color: #1b74e4;
}

.dark-theme .page-wrapper .btn-1:hover {
  background-color: #1d1d1d;
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a,
.dark-theme .page-wrapper .btn-1,
.dark-theme .page-wrapper .bostami-card-item .card-title,
.dark-theme .page-wrapper .form-btn {
  color: #fff;
}

.dark-theme .page-wrapper .bostami-parsonal-info-bio,
.dark-theme .page-wrapper .bostami-contact-item .text span {
  color: #a6a6a6;
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a:hover {
  color: #fa5252;
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li.active a {
  color: #fa5252;
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a span svg * {
  fill: #fff;
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a span img {
  filter: brightness(5);
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:hover a span svg * {
  fill: #fa5252;
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li.active a span svg * {
  fill: #fa5252;
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:hover a span img {
  filter: saturate(25);
}

.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:is(.active) a span img {
  filter: saturate(25);
}

.dark-theme .page-wrapper .bostami-what-do-item,
.dark-theme .page-wrapper .bostami-card-item,
.dark-theme .page-wrapper .blog-slider-single,
.dark-theme .page-wrapper .fillter-item {
  border: 1px solid #353535;
}

.dark-theme .page-wrapper-2 .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a span img {
  filter: brightness(5);
}

.dark-theme .page-wrapper-2 .bostami-page-area .bostami-page-wrap {
  background: #111;
}

.dark-theme .page-wrapper-2 .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a span svg * {
  fill: white;
}

.dark-theme .page-wrapper-2 .bostami-header-wrap.main-style-2 {
  background-color: transparent;
}

.dark-theme .page-wrapper-2 .bostami-main-menu-wrap {
  background: transparent;
}

.dark-theme .page-wrapper-2 .bostami-parsonal-info-area.bostami-parsonal-info-2-area {
  background: transparent;
}

.dark-theme .page-wrapper-2 .bostami-page-area .bostami-parsonal-info-contact {
  background-color: transparent;
}

.dark-theme .page-wrapper-2 .bostami-parsonal-info-contact-item .icon:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.dark-theme .home-3 .bastami-main-menu ul li:is(.active) a span svg * {
  fill: white;
}

.dark-theme .home-3 .bastami-main-menu ul li:hover a span svg * {
  fill: white;
}

.dark-theme .home-3 .bostami-header-wrap {
  background: transparent !important;
}

.dark-theme .home-3 .bostami-parsonal-info-social-link li a:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.dark-theme .home-3 .bastami-main-menu ul li:is(.active) {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.dark-theme .home-3 .bastami-main-menu ul li:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.dark-theme .home-3 .bostami-parsonal-info-contact-item .icon:hover {
  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);
}

.dark-theme .home-1 .bostami-header-wrap {
  background: transparent;
}

.dark-theme .home-1 .bastami-main-menu ul li.active a span svg * {
  fill: white;
}

.dark-theme .home-1 .bastami-main-menu ul li a span svg *,
.dark-theme .home-3 .bastami-main-menu ul li a span svg * {
  fill: #a6a6a6;
}

.dark-theme .home-1 .bastami-main-menu ul li:hover a span svg * {
  fill: white;
}

.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a:hover {
  color: #1b74e4;
}

.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li.active a {
  color: #1b74e4;
}

.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li.active a span svg * {
  fill: #1b74e4;
}

.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:hover a span svg * {
  fill: #1b74e4;
}

.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:hover a span img {
  filter: saturate(25);
}

.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:is(.active) a span img {
  filter: saturate(25);
}

.dark-theme .h1-modal-box .modal-dialog {
  background-color: #323232;
}

.dark-theme .h1-modal-box .modal-dialog .modal-content {
  background-color: #323232;
}

.dark-theme .h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box textarea {
  background: #000;
  color: white;
}

.dark-theme .portfolio-modal-box .modal-dialog {
  background-color: #323232;
}

.dark-theme .portfolio-modal-box .modal-dialog .modal-content {
  background-color: #323232;
}

.dark-theme .portfolio-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box textarea {
  background: #000;
  color: white;
}

.dark-theme .bostami-parsonal-info-contact-item:not(:first-child) {
  border-color: #333;
}

.dark-theme .contact-form .input-box {
  border-bottom-color: #333;
}

.dark-theme .bostami-parsonal-info-btn .btn-2 {
  color: #fff;
}

@media print {
  .print-area {
    width: 250px;
    /* Ancho fijo */
    height: auto;
    /* Alto automático */
    overflow: none;
    /* Asegura que el contenido se muestre completamente */
    box-sizing: border-box;
    /* Incluye bordes y rellenos en el ancho total */
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/main.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;iEAAA;AA+BA;;;;;iEAAA;AAQA;EACE,uBAAA;EACA,2BAAA;EACA,oBAAA;EACA,wBAAA;EACA,0BAAA;EACA,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yCAAA;AAAF;;AAGA;EACE,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,0BAAA;EACA,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;;EAEE,eAAA;EAKA,gBAAA;AAAF;;AAGA;;;EAOE,gBAAA;AAAF;;AAGA;;EAEE,qBAAA;EACA,aAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,qBAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,oBAAA;EACA,qBAAA;AAAF;;AAGA;;;;;EAKE,UAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,0BAAA;AAAF;;AAGA;;;;;;EAME,kCAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;AAAF;;AAGA;;;;;;EAME,cAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,6CAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AAAF;;AAGA;EACE,8BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAeA;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;AAAF;;AAGA,6CAAA;;AAyFA;;EAEE,UAAA;AAAF;;AAGA,0CAAA;AACA;EACE,WAAA;AAAF;;AAGA,mCAAA;AACA;EACE,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AAAF;;AAGA,8CAAA;AACA;EACE,eAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE;IACE,iBAAA;EAAF;AACF;AAGA,uCAAA;AACA;EACE,iCAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE,sCAAA;AADF;;AAIA;EACE,sBAAA;EACA,kCAAA;EACA,4BAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,SAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;;;;;iEAAA;AAMA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,sCAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;AADF;;AAIA;EACE,qBAAA;EACA,iBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE,oCAAA;EACA,sCAAA;EACA,0BAAA;AADF;;AAIA;EACE,qCAAA;AADF;;AAIA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,+EAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AADF;;AAIA;EACE,qBAAA;EACA,iBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;;EAEE,4DAAA;EACA,qFAAA;EACA,yBAAA;EACA,2BAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;AADF;;AAIA;EACE,wCAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,sCAAA;AADF;;AAIA;EACE,sCAAA;EACA,kCAAA;EACA,WAAA;AADF;;AAIA;EACE,+EAAA;EACA,yBAAA;AADF;;AAIA;EACE,+EAAA;EACA,yBAAA;AADF;;AAIA;;;;;iEAAA;AAMA;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,kCAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AADF;;AAIA;EACE;IACE,kBAAA;EADF;AACF;AAIA;EAGE;IACE,kBAAA;EAJF;AACF;AAOA;EACE,iBAAA;EACA,oBAAA;AALF;;AAQA;EACE,iBAAA;AALF;;AAQA;EACE,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,qBAAA;EACA,+BAAA;AALF;;AAQA;EAGE;IACE,eAAA;EAPF;AACF;AAUA;EACE;IACE,eAAA;EARF;AACF;AAWA;EACE;IACE,eAAA;EATF;AACF;AAYA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AAVF;;AAaA;EACE;IACE,UAAA;EAVF;AACF;AAaA;EACE;IACE,WAAA;EAXF;AACF;AAcA;EACE,qCAAA;EACA,mBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,iBAAA;EACA,gBAAA;AAZF;;AAeA;EAIE;IACE,eAAA;EAfF;AACF;AAkBA;EACE;IACE,kBAAA;EAhBF;AACF;AAmBA;EACE;IACE,kBAAA;EAjBF;AACF;AAoBA;EACE;IACE,mBAAA;EAlBF;AACF;AAqBA;EACE;IACE,mBAAA;EAnBF;AACF;AAsBA;EACE,gBAAA;EACA,mBAAA;AApBF;;AAuBA;EAEE;IACE,kBAAA;EArBF;AACF;AAwBA;EACE;IACE,kBAAA;EAtBF;AACF;AAyBA;EACE;IACE,kBAAA;EAvBF;AACF;AA0BA;EAEE;IACE,mBAAA;EAzBF;AACF;AA4BA;EACE;IACE,mBAAA;EA1BF;AACF;AA6BA;EACE;IACE,mBAAA;EA3BF;AACF;AA8BA;EACE,gBAAA;AA5BF;;AA+BA;EACE,gBAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,mBAAA;AA5BF;;AA+BA;EACE,4BAAA;EACA,+EAAA;AA5BF;;AA+BA;EACE;IACE,UAAA;EA5BF;AACF;AA+BA;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AA7BF;;AAgCA;EACE,uBAAA;EACA,iBAAA;EACA,iBAAA;AA7BF;;AAgCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA7BF;;AAgCA;EACE,qFAAA;EACA,sCAAA;AA7BF;;AAgCA;EACE,iBAAA;EACA,oBAAA;AA7BF;;AAgCA;EACE,oBAAA;EACA,6BAAA;AA7BF;;AAgCA;EAIE;IACE,mBAAA;EAhCF;AACF;AAmCA;EACE,6BAAA;AAjCF;;AAoCA;EACE,iBAAA;EACA,oBAAA;AAjCF;;AAoCA;;;;;iEAAA;AAMA;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,6DAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,2BAAA;AAjCF;;AAoCA;EACE,0BAAA;AAjCF;;AAoCA;EACE,6DAAA;AAjCF;;AAoCA;EACE,wBAAA;AAjCF;;AAoCA;EACE,yBAAA;AAjCF;;AAoCA;EACE,2BAAA;AAjCF;;AAoCA;EACE,kBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,oBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;AAjCF;;AAoCA;EACE,qCAAA;EACA,mBAAA;EACA,gDAAA;EACA,iBAAA;EACA,oBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,qCAAA;AAjCF;;AAoCA;EACE,YAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAjCF;;AAoCA;EACE;IACE,gBAAA;EAjCF;AACF;AAoCA;EACE,qBAAA;AAlCF;;AAqCA;EACE,sBAAA;EACA,iBAAA;AAlCF;;AAqCA;EACE,6BAAA;AAlCF;;AAqCA;EACE,4BAAA;AAlCF;;AAqCA;EACE;IACE,iBAAA;EAlCF;AACF;AAqCA;EACE,6BAAA;AAnCF;;AAsCA;EACE,4BAAA;AAnCF;;AAsCA;EACE,oBAAA;AAnCF;;AAsCA;EACE,oCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAnCF;;AAsCA;EACE,mBAAA;AAnCF;;AAsCA;EACE,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AAnCF;;AAsCA;EACE,cAAA;EACA,mBAAA;AAnCF;;AAsCA;EACE,sCAAA;AAnCF;;AAsCA;EACE,0BAAA;AAnCF;;AAsCA;EACE,yBAAA;AAnCF;;AAsCA;EACE,qBAAA;AAnCF;;AAsCA;EACE,sCAAA;AAnCF;;AAsCA;EACE,0BAAA;AAnCF;;AAsCA;EACE,yBAAA;AAnCF;;AAsCA;EACE,qBAAA;AAnCF;;AAsCA;EACE,8BAAA;AAnCF;;AAsCA;EACE,gCAAA;AAnCF;;AAsCA;;EAEE,gCAAA;AAnCF;;AAsCA;EACE,4BAAA;AAnCF;;AAsCA;EACE,WAAA;AAnCF;;AAsCA;EACE,4BAAA;AAnCF;;AAsCA;EACE,iBAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAnCF;;AAsCA;EACE,6BAAA;AAnCF;;AAsCA;EACE,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;AAnCF;;AAsCA;EACE,qBAAA;AAnCF;;AAsCA;EACE,qBAAA;AAnCF;;AAsCA;EACE,qBAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAnCF;;AAsCA;EACE,iBAAA;AAnCF;;AAsCA;EACE;IACE,gBAAA;EAnCF;AACF;AAsCA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AApCF;;AAuCA;EACE;IACE,iBAAA;EApCF;AACF;AAuCA;EACE,4BAAA;EACA,+EAAA;AArCF;;AAwCA;EACE,qBAAA;EACA,gBAAA;EACA,iBAAA;AArCF;;AAwCA;EACE,WAAA;AArCF;;AAwCA;EACE,4BAAA;EACA,+EAAA;AArCF;;AAwCA;EACE,cAAA;AArCF;;AAwCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AArCF;;AAwCA;EAEE;IACE,mBAAA;EAtCF;AACF;AAyCA;EACE,YAAA;AAvCF;;AA0CA;EACE;IACE,YAAA;EAvCF;AACF;AA0CA;EACE;IACE,YAAA;EAxCF;AACF;AA2CA;EACE,oEAAA;AAzCF;;AA4CA;EACE,iBAAA;EACA,mBAAA;AAzCF;;AA4CA;EAEE;IACE,gBAAA;EA1CF;AACF;AA6CA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;AA3CF;;AA8CA;EAEE;IACE,aAAA;EA5CF;AACF;AA+CA;EACE,oBAAA;EACA,gBAAA;AA7CF;;AAgDA;EACE,iBAAA;AA7CF;;AAgDA;EACE,qFAAA;EACA,sCAAA;AA7CF;;AAgDA;EACE,qFAAA;EACA,sCAAA;AA7CF;;AAgDA;EACE,eAAA;AA7CF;;AAgDA;EACE,WAAA;EACA,YAAA;AA7CF;;AAgDA;EACE,qFAAA;EACA,sCAAA;AA7CF;;AAgDA;EACE,oBAAA;AA7CF;;AAgDA;EAIE;IACE,mBAAA;EAhDF;AACF;AAmDA;EACE,mBAAA;EACA,mBAAA;EACA,6BAAA;AAjDF;;AAoDA;EACE;IACE,kBAAA;IACA,mBAAA;EAjDF;AACF;AAoDA;EAIE;IACE,gBAAA;IACA,iBAAA;EArDF;AACF;AAwDA;EACE,WAAA;EACA,YAAA;AAtDF;;AAyDA;EAGE;IACE,aAAA;EAxDF;AACF;AA2DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;;;;;iEAAA;AAMA;EACE,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AAzDF;;AA4DA;EACE;IACE,YAAA;IACA,kBAAA;EAzDF;AACF;AA4DA;EACE;IACE,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,UAAA;EA1DF;AACF;AA6DA;EAEE;IACE,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,UAAA;EA5DF;AACF;AA+DA;EACE;IACE,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,kBAAA;EA7DF;AACF;AAgEA;EACE;IACE,kBAAA;EA9DF;AACF;AAiEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA/DF;;AAkEA;EACE;IACE,YAAA;IACA,aAAA;IACA,eAAA;EA/DF;AACF;AAkEA;EAGE;IACE,eAAA;EAlEF;AACF;AAqEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAnEF;;AAsEA;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,iCAAA;EACA,kBAAA;AAnEF;;AAsEA;EACE,mBAAA;AAnEF;;AAsEA;EACE,WAAA;AAnEF;;AAsEA;EACE;IACE,eAAA;EAnEF;AACF;AAsEA;EAEE;IACE,eAAA;EArEF;AACF;AAwEA;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,kCAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAtEF;;AAyEA;EAGE;IACE,eAAA;EAxEF;AACF;AA2EA;EACE,qBAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,sCAAA;AAzEF;;AA4EA;EACE,yCAAA;AAzEF;;AA4EA;EACE,cAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE;IACE,kBAAA;EAzEF;AACF;AA4EA;EACE;IACE,kBAAA;EA1EF;AACF;AA6EA;EACE;IACE,kBAAA;EA3EF;AACF;AA8EA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;AA5EF;;AA+EA;EACE,6BAAA;AA5EF;;AA+EA;EACE,cAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,gBAAA;AA5EF;;AA+EA;EACE;IACE,WAAA;IACA,YAAA;IACA,iBAAA;IACA,gBAAA;EA5EF;AACF;AA+EA;EACE,gBAAA;AA7EF;;AAgFA;EACE,sCAAA;EACA,yCAAA;AA7EF;;AAkFA;EACE,qBAAA;AA/EF;;AAkFA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;AA/EF;;AAkFA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,gBAAA;AA/EF;;AAkFA;EACE;IACE,eAAA;EA/EF;AACF;AAkFA;EACE,6BAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAhFF;;AAmFA;EACE;IACE,gBAAA;EAhFF;AACF;AAmFA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAjFF;;AAoFA;EAEE;IACE,YAAA;IACA,aAAA;EAlFF;AACF;AAqFA;EACE,uBAAA;EACA,cAAA;AAnFF;;AAsFA;EACE,+EAAA;AAnFF;;AAsFA;EACE,WAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;AAnFF;;AAsFA;EACE,gBAAA;AAnFF;;AAsFA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AAnFF;;AAsFA;EACE,+EAAA;AAnFF;;AAsFA;EACE,WAAA;EACA,cAAA;AAnFF;;AAsFA;EACE;IACE,kBAAA;EAnFF;AACF;AAsFA;EACE;IACE,eAAA;EApFF;AACF;AAuFA;EACE,+EAAA;AArFF;;AAwFA;EACE,+EAAA;AArFF;;AAwFA;;;;;iEAAA;AAMA;EACE,iBAAA;EACA,oBAAA;EACA,sCAAA;AArFF;;AAwFA;EACE,iBAAA;EACA,YAAA;AArFF;;AAwFA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;AArFF;;AAwFA;EACE;IACE,YAAA;IACA,aAAA;EArFF;AACF;AAwFA;EACE,6BAAA;AAtFF;;AAyFA;;;;;iEAAA;AAMA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;AAtFF;;AAyFA;EACE;IACE,eAAA;EAtFF;AACF;AAyFA;EACE;IACE,iBAAA;EAvFF;AACF;AA0FA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAxFF;;AA2FA;EAGE;IACE,eAAA;EA1FF;AACF;AA6FA;EACE;IACE,eAAA;EA3FF;AACF;AA8FA;EACE;IACE,eAAA;EA5FF;AACF;AA+FA;EACE,gBAAA;EACA,iBAAA;AA7FF;;AAgGA;EACE,mBAAA;EACA,kBAAA;AA7FF;;AAgGA;EACE;IACE,eAAA;EA7FF;AACF;AAgGA;EACE;IACE,eAAA;EA9FF;AACF;AAiGA;EACE;IACE,eAAA;EA/FF;AACF;AAkGA;;;;;iEAAA;AAMA;EAEE;IACE,mBAAA;EAjGF;AACF;AAoGA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAlGF;;AAqGA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAlGF;;AAqGA;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;AAlGF;;AAqGA;EACE,uBAAA;AAlGF;;AAqGA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAlGF;;AAqGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAlGF;;AAqGA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAlGF;;AAqGA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAlGF;;AAqGA;EACE,sCAAA;AAlGF;;AAqGA;EAEE;IACE,mBAAA;EAnGF;AACF;AAsGA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AApGF;;AAuGA;EACE,YAAA;EACA,sBAAA;AApGF;;AAuGA;EACE,yBAAA;AApGF;;AAuGA;EACE,yBAAA;AApGF;;AAuGA;EACE,yBAAA;AApGF;;AAuGA;EACE,yBAAA;AApGF;;AAuGA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AApGF;;AAuGA;EACE;IACE,kBAAA;IACA,mBAAA;EApGF;AACF;AAuGA;EACE;IACE,kBAAA;IACA,mBAAA;EArGF;AACF;AAwGA;EACE;IACE,kBAAA;IACA,mBAAA;EAtGF;AACF;AAyGA;EACE;IACE,kBAAA;IACA,mBAAA;EAvGF;AACF;AA0GA;EACE,mBAAA;AAxGF;;AA2GA;;;;;iEAAA;AAMA;EACE,iBAAA;AAxGF;;AA2GA;EACE;IACE,gBAAA;EAxGF;AACF;AA2GA;EACE;IACE,iBAAA;EAzGF;AACF;AA4GA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AA1GF;;AA6GA;EACE,2BAAA;AA1GF;;AA6GA;EACE,2BAAA;AA1GF;;AA6GA;EACE,qBAAA;EACA,mBAAA;EACA,aAAA;AA1GF;;AA6GA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA1GF;;AA6GA;EACE,qBAAA;AA1GF;;AA6GA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AA1GF;;AA6GA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AA1GF;;AA6GA;EACE,2BAAA;AA1GF;;AA6GA;;EAEE,UAAA;EACA,eAAA;AA1GF;;AA6GA;EAEE;;IAEE,WAAA;EA3GF;AACF;AA8GA;;EAEE,mBAAA;AA5GF;;AA+GA;EACE,eAAA;EACA,gBAAA;EACA,6CAAA;AA5GF;;AA+GA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AA5GF;;AA+GA;EACE;IACE,gBAAA;EA5GF;AACF;AA+GA;EACE;IACE,cAAA;IACA,aAAA;EA7GF;AACF;AAgHA;EACE;IACE,cAAA;IACA,aAAA;EA9GF;AACF;AAiHA;EACE,WAAA;AA/GF;;AAkHA;EACE,yBAAA;EACA,mBAAA;AA/GF;;AAkHA;EACE,mBAAA;EACA,mBAAA;AA/GF;;AAkHA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AA/GF;;AAkHA;EACE,qBAAA;EACA,eAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AA/GF;;AAkHA;EACE;IACE,UAAA;IACA,OAAA;EA/GF;AACF;AAkHA;EACE;IACE,UAAA;IACA,OAAA;EAhHF;AACF;AAmHA;EACE;IACE,UAAA;IACA,OAAA;EAjHF;AACF;AAoHA;EACE;IACE,SAAA;IACA,QAAA;EAlHF;AACF;AAqHA;EACE;IACE,SAAA;IACA,OAAA;EAnHF;AACF;AAsHA;EACE;IACE,SAAA;IACA,OAAA;EApHF;AACF;AAuHA;EACE;IACE,SAAA;IACA,OAAA;EArHF;AACF;AAwHA;EACE;IACE,SAAA;IACA,OAAA;EAtHF;AACF;AAyHA;EACE,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAvHF;;AA0HA;EACE;IACE,qBAAA;IACA,cAAA;EAvHF;AACF;AA0HA;EACE,aAAA;EACA,qBAAA;EACA,cAAA;AAxHF;;AA2HA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AAxHF;;AA2HA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAxHF;;AA2HA;EACE;IACE,gBAAA;IACA,eAAA;EAxHF;AACF;AA2HA;EACE,mBAAA;AAzHF;;AA4HA;EACE,eAAA;EACA,gBAAA;AAzHF;;AA4HA;EACE;IACE,eAAA;EAzHF;AACF;AA4HA;EACE;IACE,eAAA;EA1HF;AACF;AA6HA;EACE;IACE,eAAA;EA3HF;AACF;AA8HA;EACE,qBAAA;EACA,kBAAA;AA5HF;;AA+HA;EACE,gBAAA;AA5HF;;AA+HA;EACE,qBAAA;EACA,gBAAA;AA5HF;;AA+HA;EACE,cAAA;AA5HF;;AA+HA;EACE,mBAAA;AA5HF;;AA+HA;;EAEE,aAAA;EACA,eAAA;AA5HF;;AA+HA;EAEE;;IAEE,aAAA;EA7HF;AACF;AAgIA;EAEE;;IAEE,UAAA;EA/HF;AACF;AAkIA;EAEE;;IAEE,WAAA;EAjIF;AACF;AAoIA;EACE,cAAA;AAlIF;;AAqIA;EACE,cAAA;AAlIF;;AAqIA;EACE,cAAA;AAlIF;;AAqIA;EACE,cAAA;AAlIF;;AAqIA;EACE,cAAA;AAlIF;;AAqIA;EACE,cAAA;AAlIF;;AAqIA;;;;;iEAAA;AAMA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AAlIF;;AAqIA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAlIF;;AAqIA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAlIF;;AAqIA;EACE,qBAAA;AAlIF;;AAqIA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;AAlIF;;AAqIA;EACE,kBAAA;EACA,kBAAA;AAlIF;;AAqIA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;AAlIF;;AAqIA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AAlIF;;AAqIA;EACE,2BAAA;AAlIF;;AAqIA;EACE,kBAAA;AAlIF;;AAqIA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,iDAAA;EACA,0BAAA;EACA,UAAA;AAlIF;;AAqIA;EACE,sCAAA;AAlIF;;AAqIA;EACE,eAAA;EACA,gBAAA;EACA,6CAAA;AAlIF;;AAqIA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AAlIF;;AAqIA;EACE;IACE,gBAAA;EAlIF;AACF;AAqIA;EACE;IACE,cAAA;IACA,aAAA;EAnIF;AACF;AAsIA;EACE;IACE,cAAA;IACA,aAAA;EApIF;AACF;AAuIA;EACE,WAAA;AArIF;;AAwIA;EACE,yBAAA;EACA,mBAAA;AArIF;;AAwIA;EACE,mBAAA;EACA,mBAAA;AArIF;;AAwIA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AArIF;;AAwIA;EACE,qBAAA;EACA,eAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AArIF;;AAwIA;EACE;IACE,UAAA;IACA,OAAA;EArIF;AACF;AAwIA;EACE;IACE,UAAA;IACA,OAAA;EAtIF;AACF;AAyIA;EACE;IACE,UAAA;IACA,OAAA;EAvIF;AACF;AA0IA;EACE;IACE,SAAA;IACA,QAAA;EAxIF;AACF;AA2IA;EACE;IACE,SAAA;IACA,OAAA;EAzIF;AACF;AA4IA;EACE;IACE,UAAA;IACA,OAAA;EA1IF;AACF;AA6IA;EACE;IACE,SAAA;IACA,OAAA;EA3IF;AACF;AA8IA;EACE;IACE,SAAA;IACA,OAAA;EA5IF;AACF;AA+IA;EACE,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AA7IF;;AAgJA;EACE;IACE,qBAAA;IACA,cAAA;EA7IF;AACF;AAgJA;EACE,aAAA;EACA,qBAAA;EACA,cAAA;AA9IF;;AAiJA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AA9IF;;AAiJA;EACE,mBAAA;AA9IF;;AAiJA;;EAEE,eAAA;EACA,kBAAA;AA9IF;;AAiJA;EACE,eAAA;EACA,gBAAA;AA9IF;;AAiJA;EACE;IACE,eAAA;EA9IF;AACF;AAiJA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AA/IF;;AAkJA;EACE;IACE,eAAA;IACA,SAAA;EA/IF;AACF;AAkJA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAhJF;;AAmJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAhJF;;AAmJA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAhJF;;AAmJA;EACE,eAAA;AAhJF;;AAmJA;EACE,kBAAA;AAhJF;;AAmJA;EACE,gBAAA;AAhJF;;AAmJA;EACE,cAAA;AAhJF;;AAmJA;EACE,eAAA;EACA,gBAAA;AAhJF;;AAmJA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAhJF;;AAmJA;EACE,eAAA;EACA,cAAA;AAhJF;;AAmJA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,6DAAA;EACA,YAAA;AAhJF;;AAmJA;EACE,4DAAA;AAhJF;;AAmJA;EACE,oCAAA;AAhJF;;AAmJA;EACE,yBAAA;AAhJF;;AAmJA;EACE,cAAA;AAhJF;;AAmJA;EACE,oCAAA;AAhJF;;AAmJA;EACE,yBAAA;AAhJF;;AAmJA;EACE,cAAA;AAhJF;;AAmJA;;;;;iEAAA;AAMA;EACE,kBAAA;EACA,mBAAA;AAhJF;;AAmJA;EACE;IACE,kBAAA;EAhJF;AACF;AAmJA;EACE;IACE,kBAAA;EAjJF;AACF;AAoJA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;AAlJF;;AAqJA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAlJF;;AAqJA;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;AAlJF;;AAqJA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAlJF;;AAqJA;EACE,YAAA;AAlJF;;AAqJA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAlJF;;AAqJA;EACE;IACE,aAAA;EAlJF;AACF;AAqJA;EACE;IACE,aAAA;IACA,eAAA;EAnJF;AACF;AAsJA;EACE;IACE,aAAA;IACA,iBAAA;EApJF;AACF;AAuJA;EACE,cAAA;EACA,WAAA;AArJF;;AAwJA;EACE;IACE,WAAA;EArJF;AACF;AAwJA;EACE;IACE,WAAA;EAtJF;AACF;AAyJA;EACE;IACE,WAAA;EAvJF;AACF;AA0JA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAxJF;;AA2JA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAxJF;;AA2JA;;;;;iEAAA;AAMA,cAAA;AACA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;AAxJF;;AA2JA;;EAEE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EAGA,4BAAA;AAxJF;;AA2JA;EACE,UAAA;EACA,QAAA;AAxJF;;AA2JA;EACE,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EAGA,4BAAA;AAxJF;;AA2JA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EAIA,2BAAA;EACA,sBAAA;EAGA,oDAAA;AAxJF;;AA2JA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EAIA,4BAAA;EAGA,8CAAA;EACA,uBAAA;AAxJF;;AA2JA;EACE;IACE,UAAA;EAxJF;EA2JA;IACE,YAAA;EAzJF;AACF;AA4JA;EACE;IAIE,4BAAA;EA1JF;EA6JA;IAIE,2BAAA;EA3JF;AACF;AA8JA;EACE,gBAAA;AA5JF;;AA+JA,aAAA;AACA;EACE,UAAA;AA5JF;;AA+JA;EACE,UAAA;EACA,uBAAA;AA5JF;;AA+JA;;EAIE,yDAAA;AA5JF;;AA+JA;EACE;IACE,UAAA;EA5JF;EA+JA;IACE,SAAA;EA7JF;AACF;AAgKA;;;;;iEAAA;AAMA;EACE,sBAAA;AA9JF;;AAiKA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,WAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;AA9JF;;AAiKA;EACE;IACE,eAAA;EA9JF;AACF;AAiKA;EACE;IACE,eAAA;EA/JF;AACF;AAkKA;EAEE;IACE,aAAA;EAjKF;AACF;AAoKA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AAlKF;;AAqKA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,QAAA;EACA,WAAA;AAlKF;;AAqKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAlKF;;AAqKA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAlKF;;AAqKA;;;EAGE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;AAlKF;;AAqKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAlKF;;AAqKA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAlKF;;AAqKA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAlKF;;AAqKA;EACE;IACE,kBAAA;EAlKF;AACF;AAqKA;EACE;IACE,kBAAA;EAnKF;AACF;AAsKA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AApKF;;AAuKA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AApKF;;AAuKA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;AApKF;;AAuKA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AApKF;;AAuKA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,OAAA;AApKF;;AAuKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;AApKF;;AAuKA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,gBAAA;AApKF;;AAuKA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AApKF;;AAuKA;EACE;IACE,kBAAA;EApKF;AACF;AAuKA;EACE,+EAAA;EACA,WAAA;AArKF;;AAwKA;EACE,iBAAA;AArKF;;AAwKA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;AArKF;;AAwKA;EACE,aAAA;EACA,SAAA;AArKF;;AAwKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AArKF;;AAwKA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AArKF;;AAwKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AArKF;;AAwKA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AArKF;;AAwKA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AArKF;;AAwKA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AArKF;;AAwKA;EACE;IACE,aAAA;EArKF;AACF;AAwKA;EACE;IACE,aAAA;EAtKF;AACF;AAyKA;EACE,gBAAA;AAvKF;;AA0KA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;AAvKF;;AA0KA;EACE,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAvKF;;AA0KA;;EAEE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AAvKF;;AA0KA;;EAEE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AAvKF;;AA0KA;EACE,aAAA;EACA,kBAAA;AAvKF;;AA0KA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAvKF;;AA0KA;EACE,+EAAA;EACA,WAAA;EACA,yBAAA;AAvKF;;AA0KA;;;;;iEAAA;AAMA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAvKF;;AA0KA;EAEE;IACE,cAAA;IACA,gBAAA;EAxKF;AACF;AA2KA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;AAzKF;;AA4KA;EACE,kBAAA;AAzKF;;AA4KA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AAzKF;;AA4KA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AAzKF;;AA4KA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AAzKF;;AA4KA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAzKF;;AA4KA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;AAzKF;;AA4KA;EACE,cAAA;AAzKF;;AA4KA;EACE,yBAAA;AAzKF;;AA4KA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAzKF;;AA4KA;EACE;IACE,SAAA;EAzKF;AACF;AA4KA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AA1KF;;AA6KA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA1KF;;AA6KA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;AA1KF;;AA6KA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AA1KF;;AA6KA;EACE,qBAAA;AA1KF;;AA6KA;EACE,cAAA;AA1KF;;AA6KA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA1KF;;AA6KA;EACE,+EAAA;EACA,WAAA;AA1KF;;AA6KA;;;;;iEAAA;AAMA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AA1KF;;AA6KA;;;EAGE,sBAAA;AA1KF;;AA6KA;;;;;;EAME,yBAAA;AA1KF;;AA6KA;;;EAGE,yBAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;;EAEE,yBAAA;AA1KF;;AA6KA;EACE,WAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;EACE,WAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;;;;EAIE,6BAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;;;;EAIE,WAAA;AA1KF;;AA6KA;;EAEE,cAAA;AA1KF;;AA6KA;EACE,cAAA;AA1KF;;AA6KA;EACE,cAAA;AA1KF;;AA6KA;EACE,UAAA;AA1KF;;AA6KA;EACE,qBAAA;AA1KF;;AA6KA;EACE,aAAA;AA1KF;;AA6KA;EACE,aAAA;AA1KF;;AA6KA;EACE,oBAAA;AA1KF;;AA6KA;EACE,oBAAA;AA1KF;;AA6KA;;;;EAIE,yBAAA;AA1KF;;AA6KA;EACE,qBAAA;AA1KF;;AA6KA;EACE,gBAAA;AA1KF;;AA6KA;EACE,WAAA;AA1KF;;AA6KA;EACE,6BAAA;AA1KF;;AA6KA;EACE,uBAAA;AA1KF;;AA6KA;EACE,uBAAA;AA1KF;;AA6KA;EACE,6BAAA;AA1KF;;AA6KA;EACE,+EAAA;AA1KF;;AA6KA;EACE,WAAA;AA1KF;;AA6KA;EACE,WAAA;AA1KF;;AA6KA;EACE,kCAAA;AA1KF;;AA6KA;EACE,+EAAA;AA1KF;;AA6KA;EACE,+EAAA;AA1KF;;AA6KA;EACE,+EAAA;AA1KF;;AA6KA;EACE,+EAAA;AA1KF;;AA6KA;EACE,uBAAA;AA1KF;;AA6KA;EACE,WAAA;AA1KF;;AA6KA;;EAEE,aAAA;AA1KF;;AA6KA;EACE,WAAA;AA1KF;;AA6KA;EACE,cAAA;AA1KF;;AA6KA;EACE,cAAA;AA1KF;;AA6KA;EACE,aAAA;AA1KF;;AA6KA;EACE,aAAA;AA1KF;;AA6KA;EACE,oBAAA;AA1KF;;AA6KA;EACE,oBAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;EACE,gBAAA;EACA,YAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;EACE,gBAAA;EACA,YAAA;AA1KF;;AA6KA;EACE,kBAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;EACE,WAAA;AA1KF;;AA6KA;EACE;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,oBAAA;IACA,cAAA;IACA,sDAAA;IACA,sBAAA;IACA,gDAAA;EA1KF;AACF","sourcesContent":["@charset \"utf-8\";\n/*\n************\n*************************\n\nTemplate Name: Name - Bostami - Personal Portfolio NextJs Template\nDescription: Bostami – HTML Personal Portfolio Template can be used for many purposes. It’s a creative, minimal and clean design.It’s suitable for Designer, Developer, Specialist, Content Writer, Instructor, Photographer, Freelancer, Software Engineer, Teacher or others expert who Show their professional projects and services in digital way. It’s 100% responsive and Ultra Super Fast beacause it’s made with Latest html\nAuthor: elite-themes24\nVersion: 1.0\n\n-----------------------------------------------------------------------------------\n\nCSS INDEX\n=================== \n01. common\n02. button\n03. page\n04. header\n05. parsonal info\n06. client\n07. what do\n08. resume\n09. portfolio\n10. blog\n11. contact\n12. preloader\n13. blog details\n14. sidebar\n15. dark theme\n\n******************************************************* \n*************************************************************** */\n/*\n************\n*************************\n01. common\n******************************************************* \n*************************************************************** */\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto+Slab:wght@300;400;500;600;700;800;900&display=swap\");\n\n:root {\n  --common-white: #ffffff;\n  --common-white-two: #ffffff;\n  --common-black: #000;\n  --theme-primary: #1b74e4;\n  --theme-secondary: #fa5252;\n  --body-text: #44566c;\n  --body-heading: #000;\n  --heading-black: #0f172a;\n  --light-white: #f3f6f6;\n  --light-white-2: #f8fbfb;\n  --prink: #fff4f4;\n  --catkrill: #eef5fa;\n  --background-image: none;\n  /* Imagen por defecto */\n  background-image: var(--background-image);\n}\n\n:root .dark-theme {\n  --common-white: #000;\n  --common-black: #fff;\n  --theme-primary: #1b74e4;\n  --theme-secondary: #fa5252;\n  --body-text: #a6a6a6;\n  --body-heading: #fff;\n  --heading-black: #0f172a;\n  --light-white: #f3f6f6;\n  --light-white-2: #f8fbfb;\n  --prink: #fff4f4;\n  --catkrill: #eef5fa;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  color: var(--body-text);\n  font-size: 16px;\n  line-height: 28px;\n}\n\n.dark-theme {\n  background-color: #1a1a1a;\n}\n\n.img,\nimg {\n  max-width: 100%;\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  -ms-transition: 0.3s;\n  -o-transition: 0.3s;\n  transition: 0.3s;\n}\n\na,\n.button,\nbutton {\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  -ms-transition: 0.3s;\n  -o-transition: 0.3s;\n  transition: 0.3s;\n}\n\na:focus,\n.button:focus {\n  text-decoration: none;\n  outline: none;\n}\n\na:focus,\na:hover {\n  color: inherit;\n  text-decoration: none;\n}\n\na,\nbutton {\n  color: inherit;\n  outline: medium none;\n  text-decoration: none;\n}\n\nbutton:focus,\ninput:focus,\ninput:focus,\ntextarea,\ntextarea:focus {\n  outline: 0;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Poppins\", sans-serif;\n  color: var(--body-heading);\n  margin-top: 0px;\n  line-height: 1.5;\n  font-weight: 700;\n  text-transform: capitalize;\n  margin-bottom: 15px;\n}\n\nh1 a,\nh2 a,\nh3 a,\nh4 a,\nh5 a,\nh6 a {\n  color: inherit;\n}\n\nh1 {\n  font-size: 60px;\n}\n\nh2 {\n  font-size: 40px;\n}\n\nh3 {\n  font-size: 28px;\n}\n\nh4 {\n  font-size: 26px;\n}\n\nh5 {\n  font-size: 22px;\n}\n\nh6 {\n  font-size: 16px;\n}\n\nul {\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n}\n\np {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 27px;\n  color: var(--body-text);\n}\n\nhr {\n  border-bottom: 1px solid var(--clr-bg-gray-3);\n  border-top: 0 none;\n  padding: 0;\n  opacity: 1;\n}\n\nlabel {\n  color: var(--clr-common-black);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n*::-moz-selection {\n  background-color: #037fff;\n  color: #fff;\n  text-shadow: none;\n}\n\n::-moz-selection {\n  background-color: #037fff;\n  color: #fff;\n  text-shadow: none;\n}\n\n::selection {\n  background-color: #037fff;\n  color: #fff;\n  text-shadow: none;\n}\n\n/* <<<<<<<    Input Placeholder   >>>>>>>>> */\ninput::-webkit-input-placeholder {\n  color: var(--clr-body-text);\n  font-size: 16px;\n  opacity: 1;\n  -webkit-transition: all 0.5s linear 0s;\n  -moz-transition: all 0.5s linear 0s;\n  -ms-transition: all 0.5s linear 0s;\n  -o-transition: all 0.5s linear 0s;\n  transition: all 0.5s linear 0s;\n}\n\ninput:-moz-placeholder {\n  color: var(--clr-body-text);\n  font-size: 16px;\n  opacity: 1;\n  -webkit-transition: all 0.5s linear 0s;\n  -moz-transition: all 0.5s linear 0s;\n  -ms-transition: all 0.5s linear 0s;\n  -o-transition: all 0.5s linear 0s;\n  transition: all 0.5s linear 0s;\n}\n\ninput::-moz-placeholder {\n  color: var(--clr-body-text);\n  font-size: 16px;\n  opacity: 1;\n  -webkit-transition: all 0.5s linear 0s;\n  -moz-transition: all 0.5s linear 0s;\n  -ms-transition: all 0.5s linear 0s;\n  -o-transition: all 0.5s linear 0s;\n  transition: all 0.5s linear 0s;\n}\n\ninput:-ms-input-placeholder {\n  color: var(--clr-body-text);\n  font-size: 16px;\n  opacity: 1;\n  -webkit-transition: all 0.5s linear 0s;\n  -moz-transition: all 0.5s linear 0s;\n  -ms-transition: all 0.5s linear 0s;\n  -o-transition: all 0.5s linear 0s;\n  transition: all 0.5s linear 0s;\n}\n\ntextarea::-webkit-input-placeholder {\n  color: var(--clr-body-text);\n  font-size: 16px;\n  opacity: 1;\n  -webkit-transition: all 0.5s linear 0s;\n  -moz-transition: all 0.5s linear 0s;\n  -ms-transition: all 0.5s linear 0s;\n  -o-transition: all 0.5s linear 0s;\n  transition: all 0.5s linear 0s;\n}\n\ntextarea:-moz-placeholder {\n  color: var(--clr-body-text);\n  font-size: 16px;\n  opacity: 1;\n  -webkit-transition: all 0.5s linear 0s;\n  -moz-transition: all 0.5s linear 0s;\n  -ms-transition: all 0.5s linear 0s;\n  -o-transition: all 0.5s linear 0s;\n  transition: all 0.5s linear 0s;\n}\n\ntextarea::-moz-placeholder {\n  color: var(--clr-body-text);\n  font-size: 16px;\n  opacity: 1;\n  -webkit-transition: all 0.5s linear 0s;\n  -moz-transition: all 0.5s linear 0s;\n  -ms-transition: all 0.5s linear 0s;\n  -o-transition: all 0.5s linear 0s;\n  transition: all 0.5s linear 0s;\n}\n\ntextarea:-ms-input-placeholder {\n  color: var(--clr-body-text);\n  font-size: 16px;\n  opacity: 1;\n  -webkit-transition: all 0.5s linear 0s;\n  -moz-transition: all 0.5s linear 0s;\n  -ms-transition: all 0.5s linear 0s;\n  -o-transition: all 0.5s linear 0s;\n  transition: all 0.5s linear 0s;\n}\n\ninput:focus::placeholder,\ntextarea:focus::placeholder {\n  opacity: 0;\n}\n\n/* <<<<<<<    Common Classes   >>>>>>>>> */\n.w_img img {\n  width: 100%;\n}\n\n/* <<<<<<<    Overlay   >>>>>>>>> */\n[data-overlay] {\n  position: relative;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n}\n\n[data-overlay]::before {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  content: \"\";\n}\n\n/* <<<<<<<    Margin & Padding     >>>>>>>>> */\n.mt-5 {\n  margin-top: 5px;\n}\n\n.mt-10 {\n  margin-top: 10px;\n}\n\n.mt-15 {\n  margin-top: 15px;\n}\n\n.mt-20 {\n  margin-top: 20px;\n}\n\n.mt-25 {\n  margin-top: 25px;\n}\n\n.mt-30 {\n  margin-top: 30px;\n}\n\n.mt-35 {\n  margin-top: 35px;\n}\n\n.mt-40 {\n  margin-top: 40px;\n}\n\n.mt-45 {\n  margin-top: 45px;\n}\n\n.mt-50 {\n  margin-top: 50px;\n}\n\n.mt-55 {\n  margin-top: 55px;\n}\n\n.mt-60 {\n  margin-top: 60px;\n}\n\n.mt-65 {\n  margin-top: 65px;\n}\n\n.mt-70 {\n  margin-top: 70px;\n}\n\n.mt-75 {\n  margin-top: 75px;\n}\n\n.mt-80 {\n  margin-top: 80px;\n}\n\n.mt-85 {\n  margin-top: 85px;\n}\n\n.mt-90 {\n  margin-top: 90px;\n}\n\n.mt-95 {\n  margin-top: 95px;\n}\n\n.mt-100 {\n  margin-top: 100px;\n}\n\n.mt-105 {\n  margin-top: 105px;\n}\n\n.mt-110 {\n  margin-top: 110px;\n}\n\n.mt-115 {\n  margin-top: 115px;\n}\n\n.mt-120 {\n  margin-top: 120px;\n}\n\n.mt-125 {\n  margin-top: 125px;\n}\n\n.mt-130 {\n  margin-top: 130px;\n}\n\n.mt-135 {\n  margin-top: 135px;\n}\n\n.mt-140 {\n  margin-top: 140px;\n}\n\n.mt-145 {\n  margin-top: 145px;\n}\n\n.mt-150 {\n  margin-top: 150px;\n}\n\n.mt-155 {\n  margin-top: 155px;\n}\n\n.mt-160 {\n  margin-top: 160px;\n}\n\n.mt-165 {\n  margin-top: 165px;\n}\n\n.mt-170 {\n  margin-top: 170px;\n}\n\n.mt-175 {\n  margin-top: 175px;\n}\n\n.mt-180 {\n  margin-top: 180px;\n}\n\n.mt-185 {\n  margin-top: 185px;\n}\n\n.mt-190 {\n  margin-top: 190px;\n}\n\n.mt-195 {\n  margin-top: 195px;\n}\n\n.mt-200 {\n  margin-top: 200px;\n}\n\n.mb-5 {\n  margin-bottom: 5px;\n}\n\n.mb-10 {\n  margin-bottom: 10px;\n}\n\n.mb-15 {\n  margin-bottom: 15px;\n}\n\n.mb-20 {\n  margin-bottom: 20px;\n}\n\n.mb-25 {\n  margin-bottom: 25px;\n}\n\n.mb-30 {\n  margin-bottom: 30px;\n}\n\n.mb-35 {\n  margin-bottom: 35px;\n}\n\n.mb-40 {\n  margin-bottom: 40px;\n}\n\n.mb-45 {\n  margin-bottom: 45px;\n}\n\n.mb-50 {\n  margin-bottom: 50px;\n}\n\n.mb-55 {\n  margin-bottom: 55px;\n}\n\n.mb-60 {\n  margin-bottom: 60px;\n}\n\n.mb-65 {\n  margin-bottom: 65px;\n}\n\n.mb-70 {\n  margin-bottom: 70px;\n}\n\n.mb-75 {\n  margin-bottom: 75px;\n}\n\n.mb-80 {\n  margin-bottom: 80px;\n}\n\n.mb-85 {\n  margin-bottom: 85px;\n}\n\n.mb-90 {\n  margin-bottom: 90px;\n}\n\n.mb-95 {\n  margin-bottom: 95px;\n}\n\n.mb-100 {\n  margin-bottom: 100px;\n}\n\n.mb-105 {\n  margin-bottom: 105px;\n}\n\n.mb-110 {\n  margin-bottom: 110px;\n}\n\n.mb-115 {\n  margin-bottom: 115px;\n}\n\n.mb-120 {\n  margin-bottom: 120px;\n}\n\n.mb-125 {\n  margin-bottom: 125px;\n}\n\n.mb-130 {\n  margin-bottom: 130px;\n}\n\n.mb-135 {\n  margin-bottom: 135px;\n}\n\n.mb-140 {\n  margin-bottom: 140px;\n}\n\n.mb-145 {\n  margin-bottom: 145px;\n}\n\n.mb-150 {\n  margin-bottom: 150px;\n}\n\n.mb-155 {\n  margin-bottom: 155px;\n}\n\n.mb-160 {\n  margin-bottom: 160px;\n}\n\n.mb-165 {\n  margin-bottom: 165px;\n}\n\n.mb-170 {\n  margin-bottom: 170px;\n}\n\n.mb-175 {\n  margin-bottom: 175px;\n}\n\n.mb-180 {\n  margin-bottom: 180px;\n}\n\n.mb-185 {\n  margin-bottom: 185px;\n}\n\n.mb-190 {\n  margin-bottom: 190px;\n}\n\n.mb-195 {\n  margin-bottom: 195px;\n}\n\n.mb-200 {\n  margin-bottom: 200px;\n}\n\n.ml-5 {\n  margin-left: 5px;\n}\n\n.ml-10 {\n  margin-left: 10px;\n}\n\n.ml-15 {\n  margin-left: 15px;\n}\n\n.ml-20 {\n  margin-left: 20px;\n}\n\n.ml-25 {\n  margin-left: 25px;\n}\n\n.ml-30 {\n  margin-left: 30px;\n}\n\n.ml-35 {\n  margin-left: 35px;\n}\n\n.ml-40 {\n  margin-left: 40px;\n}\n\n.ml-45 {\n  margin-left: 45px;\n}\n\n.ml-50 {\n  margin-left: 50px;\n}\n\n.ml-55 {\n  margin-left: 55px;\n}\n\n.ml-60 {\n  margin-left: 60px;\n}\n\n.ml-65 {\n  margin-left: 65px;\n}\n\n.ml-70 {\n  margin-left: 70px;\n}\n\n.ml-75 {\n  margin-left: 75px;\n}\n\n.ml-80 {\n  margin-left: 80px;\n}\n\n.ml-85 {\n  margin-left: 85px;\n}\n\n.ml-90 {\n  margin-left: 90px;\n}\n\n.ml-95 {\n  margin-left: 95px;\n}\n\n.ml-100 {\n  margin-left: 100px;\n}\n\n.ml-105 {\n  margin-left: 105px;\n}\n\n.ml-110 {\n  margin-left: 110px;\n}\n\n.ml-115 {\n  margin-left: 115px;\n}\n\n.ml-120 {\n  margin-left: 120px;\n}\n\n.ml-125 {\n  margin-left: 125px;\n}\n\n.ml-130 {\n  margin-left: 130px;\n}\n\n.ml-135 {\n  margin-left: 135px;\n}\n\n.ml-140 {\n  margin-left: 140px;\n}\n\n.ml-145 {\n  margin-left: 145px;\n}\n\n.ml-150 {\n  margin-left: 150px;\n}\n\n.ml-155 {\n  margin-left: 155px;\n}\n\n.ml-160 {\n  margin-left: 160px;\n}\n\n.ml-165 {\n  margin-left: 165px;\n}\n\n.ml-170 {\n  margin-left: 170px;\n}\n\n.ml-175 {\n  margin-left: 175px;\n}\n\n.ml-180 {\n  margin-left: 180px;\n}\n\n.ml-185 {\n  margin-left: 185px;\n}\n\n.ml-190 {\n  margin-left: 190px;\n}\n\n.ml-195 {\n  margin-left: 195px;\n}\n\n.ml-200 {\n  margin-left: 200px;\n}\n\n.mr-5 {\n  margin-right: 5px;\n}\n\n.mr-10 {\n  margin-right: 10px;\n}\n\n.mr-15 {\n  margin-right: 15px;\n}\n\n.mr-20 {\n  margin-right: 20px;\n}\n\n.mr-25 {\n  margin-right: 25px;\n}\n\n.mr-30 {\n  margin-right: 30px;\n}\n\n.mr-35 {\n  margin-right: 35px;\n}\n\n.mr-40 {\n  margin-right: 40px;\n}\n\n.mr-45 {\n  margin-right: 45px;\n}\n\n.mr-50 {\n  margin-right: 50px;\n}\n\n.mr-55 {\n  margin-right: 55px;\n}\n\n.mr-60 {\n  margin-right: 60px;\n}\n\n.mr-65 {\n  margin-right: 65px;\n}\n\n.mr-70 {\n  margin-right: 70px;\n}\n\n.mr-75 {\n  margin-right: 75px;\n}\n\n.mr-80 {\n  margin-right: 80px;\n}\n\n.mr-85 {\n  margin-right: 85px;\n}\n\n.mr-90 {\n  margin-right: 90px;\n}\n\n.mr-95 {\n  margin-right: 95px;\n}\n\n.mr-100 {\n  margin-right: 100px;\n}\n\n.mr-105 {\n  margin-right: 105px;\n}\n\n.mr-110 {\n  margin-right: 110px;\n}\n\n.mr-115 {\n  margin-right: 115px;\n}\n\n.mr-120 {\n  margin-right: 120px;\n}\n\n.mr-125 {\n  margin-right: 125px;\n}\n\n.mr-130 {\n  margin-right: 130px;\n}\n\n.mr-135 {\n  margin-right: 135px;\n}\n\n.mr-140 {\n  margin-right: 140px;\n}\n\n.mr-145 {\n  margin-right: 145px;\n}\n\n.mr-150 {\n  margin-right: 150px;\n}\n\n.mr-155 {\n  margin-right: 155px;\n}\n\n.mr-160 {\n  margin-right: 160px;\n}\n\n.mr-165 {\n  margin-right: 165px;\n}\n\n.mr-170 {\n  margin-right: 170px;\n}\n\n.mr-175 {\n  margin-right: 175px;\n}\n\n.mr-180 {\n  margin-right: 180px;\n}\n\n.mr-185 {\n  margin-right: 185px;\n}\n\n.mr-190 {\n  margin-right: 190px;\n}\n\n.mr-195 {\n  margin-right: 195px;\n}\n\n.mr-200 {\n  margin-right: 200px;\n}\n\n.pt-5 {\n  padding-top: 5px;\n}\n\n.pt-10 {\n  padding-top: 10px;\n}\n\n.pt-15 {\n  padding-top: 15px;\n}\n\n.pt-20 {\n  padding-top: 20px;\n}\n\n.pt-25 {\n  padding-top: 25px;\n}\n\n.pt-30 {\n  padding-top: 30px;\n}\n\n.pt-35 {\n  padding-top: 35px;\n}\n\n.pt-40 {\n  padding-top: 40px;\n}\n\n.pt-45 {\n  padding-top: 45px;\n}\n\n.pt-50 {\n  padding-top: 50px;\n}\n\n.pt-55 {\n  padding-top: 55px;\n}\n\n.pt-60 {\n  padding-top: 60px;\n}\n\n.pt-65 {\n  padding-top: 65px;\n}\n\n.pt-70 {\n  padding-top: 70px;\n}\n\n.pt-75 {\n  padding-top: 75px;\n}\n\n.pt-80 {\n  padding-top: 80px;\n}\n\n.pt-85 {\n  padding-top: 85px;\n}\n\n.pt-90 {\n  padding-top: 90px;\n}\n\n.pt-95 {\n  padding-top: 95px;\n}\n\n.pt-100 {\n  padding-top: 100px;\n}\n\n.pt-105 {\n  padding-top: 105px;\n}\n\n.pt-110 {\n  padding-top: 110px;\n}\n\n.pt-115 {\n  padding-top: 115px;\n}\n\n.pt-120 {\n  padding-top: 120px;\n}\n\n.pt-125 {\n  padding-top: 125px;\n}\n\n.pt-130 {\n  padding-top: 130px;\n}\n\n.pt-135 {\n  padding-top: 135px;\n}\n\n.pt-140 {\n  padding-top: 140px;\n}\n\n.pt-145 {\n  padding-top: 145px;\n}\n\n.pt-150 {\n  padding-top: 150px;\n}\n\n.pt-155 {\n  padding-top: 155px;\n}\n\n.pt-160 {\n  padding-top: 160px;\n}\n\n.pt-165 {\n  padding-top: 165px;\n}\n\n.pt-170 {\n  padding-top: 170px;\n}\n\n.pt-175 {\n  padding-top: 175px;\n}\n\n.pt-180 {\n  padding-top: 180px;\n}\n\n.pt-185 {\n  padding-top: 185px;\n}\n\n.pt-190 {\n  padding-top: 190px;\n}\n\n.pt-195 {\n  padding-top: 195px;\n}\n\n.pt-200 {\n  padding-top: 200px;\n}\n\n.pb-5 {\n  padding-bottom: 5px;\n}\n\n.pb-10 {\n  padding-bottom: 10px;\n}\n\n.pb-15 {\n  padding-bottom: 15px;\n}\n\n.pb-20 {\n  padding-bottom: 20px;\n}\n\n.pb-25 {\n  padding-bottom: 25px;\n}\n\n.pb-30 {\n  padding-bottom: 30px;\n}\n\n.pb-35 {\n  padding-bottom: 35px;\n}\n\n.pb-40 {\n  padding-bottom: 40px;\n}\n\n.pb-45 {\n  padding-bottom: 45px;\n}\n\n.pb-50 {\n  padding-bottom: 50px;\n}\n\n.pb-55 {\n  padding-bottom: 55px;\n}\n\n.pb-60 {\n  padding-bottom: 60px;\n}\n\n.pb-65 {\n  padding-bottom: 65px;\n}\n\n.pb-70 {\n  padding-bottom: 70px;\n}\n\n.pb-75 {\n  padding-bottom: 75px;\n}\n\n.pb-80 {\n  padding-bottom: 80px;\n}\n\n.pb-85 {\n  padding-bottom: 85px;\n}\n\n.pb-90 {\n  padding-bottom: 90px;\n}\n\n.pb-95 {\n  padding-bottom: 95px;\n}\n\n.pb-100 {\n  padding-bottom: 100px;\n}\n\n.pb-105 {\n  padding-bottom: 105px;\n}\n\n.pb-110 {\n  padding-bottom: 110px;\n}\n\n.pb-115 {\n  padding-bottom: 115px;\n}\n\n.pb-120 {\n  padding-bottom: 120px;\n}\n\n.pb-125 {\n  padding-bottom: 125px;\n}\n\n.pb-130 {\n  padding-bottom: 130px;\n}\n\n.pb-135 {\n  padding-bottom: 135px;\n}\n\n.pb-140 {\n  padding-bottom: 140px;\n}\n\n.pb-145 {\n  padding-bottom: 145px;\n}\n\n.pb-150 {\n  padding-bottom: 150px;\n}\n\n.pb-155 {\n  padding-bottom: 155px;\n}\n\n.pb-160 {\n  padding-bottom: 160px;\n}\n\n.pb-165 {\n  padding-bottom: 165px;\n}\n\n.pb-170 {\n  padding-bottom: 170px;\n}\n\n.pb-175 {\n  padding-bottom: 175px;\n}\n\n.pb-180 {\n  padding-bottom: 180px;\n}\n\n.pb-185 {\n  padding-bottom: 185px;\n}\n\n.pb-190 {\n  padding-bottom: 190px;\n}\n\n.pb-195 {\n  padding-bottom: 195px;\n}\n\n.pb-200 {\n  padding-bottom: 200px;\n}\n\n.pb-205 {\n  padding-bottom: 205px;\n}\n\n.pb-210 {\n  padding-bottom: 210px;\n}\n\n.pb-215 {\n  padding-bottom: 215px;\n}\n\n.pb-220 {\n  padding-bottom: 220px;\n}\n\n.pb-225 {\n  padding-bottom: 225px;\n}\n\n.pb-230 {\n  padding-bottom: 230px;\n}\n\n.pb-235 {\n  padding-bottom: 235px;\n}\n\n.pb-240 {\n  padding-bottom: 240px;\n}\n\n.pb-245 {\n  padding-bottom: 245px;\n}\n\n.pb-250 {\n  padding-bottom: 250px;\n}\n\n.pb-255 {\n  padding-bottom: 255px;\n}\n\n.pb-260 {\n  padding-bottom: 260px;\n}\n\n.pb-265 {\n  padding-bottom: 265px;\n}\n\n.pb-270 {\n  padding-bottom: 270px;\n}\n\n.pb-275 {\n  padding-bottom: 275px;\n}\n\n.pb-280 {\n  padding-bottom: 280px;\n}\n\n.pb-285 {\n  padding-bottom: 285px;\n}\n\n.pb-290 {\n  padding-bottom: 290px;\n}\n\n.pb-295 {\n  padding-bottom: 295px;\n}\n\n.pb-300 {\n  padding-bottom: 300px;\n}\n\n.pl-5 {\n  padding-left: 5px;\n}\n\n.pl-10 {\n  padding-left: 10px;\n}\n\n.pl-15 {\n  padding-left: 15px;\n}\n\n.pl-20 {\n  padding-left: 20px;\n}\n\n.pl-25 {\n  padding-left: 25px;\n}\n\n.pl-30 {\n  padding-left: 30px;\n}\n\n.pl-35 {\n  padding-left: 35px;\n}\n\n.pl-40 {\n  padding-left: 40px;\n}\n\n.pl-45 {\n  padding-left: 45px;\n}\n\n.pl-50 {\n  padding-left: 50px;\n}\n\n.pl-55 {\n  padding-left: 55px;\n}\n\n.pl-60 {\n  padding-left: 60px;\n}\n\n.pl-65 {\n  padding-left: 65px;\n}\n\n.pl-70 {\n  padding-left: 70px;\n}\n\n.pl-75 {\n  padding-left: 75px;\n}\n\n.pl-80 {\n  padding-left: 80px;\n}\n\n.pl-85 {\n  padding-left: 85px;\n}\n\n.pl-90 {\n  padding-left: 90px;\n}\n\n.pl-95 {\n  padding-left: 95px;\n}\n\n.pl-100 {\n  padding-left: 100px;\n}\n\n.pl-105 {\n  padding-left: 105px;\n}\n\n.pl-110 {\n  padding-left: 110px;\n}\n\n.pl-115 {\n  padding-left: 115px;\n}\n\n.pl-120 {\n  padding-left: 120px;\n}\n\n.pl-125 {\n  padding-left: 125px;\n}\n\n.pl-130 {\n  padding-left: 130px;\n}\n\n.pl-135 {\n  padding-left: 135px;\n}\n\n.pl-140 {\n  padding-left: 140px;\n}\n\n.pl-145 {\n  padding-left: 145px;\n}\n\n.pl-150 {\n  padding-left: 150px;\n}\n\n.pl-155 {\n  padding-left: 155px;\n}\n\n.pl-160 {\n  padding-left: 160px;\n}\n\n.pl-165 {\n  padding-left: 165px;\n}\n\n.pl-170 {\n  padding-left: 170px;\n}\n\n.pl-175 {\n  padding-left: 175px;\n}\n\n.pl-180 {\n  padding-left: 180px;\n}\n\n.pl-185 {\n  padding-left: 185px;\n}\n\n.pl-190 {\n  padding-left: 190px;\n}\n\n.pl-195 {\n  padding-left: 195px;\n}\n\n.pl-200 {\n  padding-left: 200px;\n}\n\n.pr-5 {\n  padding-right: 5px;\n}\n\n.pr-10 {\n  padding-right: 10px;\n}\n\n.pr-15 {\n  padding-right: 15px;\n}\n\n.pr-20 {\n  padding-right: 20px;\n}\n\n.pr-25 {\n  padding-right: 25px;\n}\n\n.pr-30 {\n  padding-right: 30px;\n}\n\n.pr-35 {\n  padding-right: 35px;\n}\n\n.pr-40 {\n  padding-right: 40px;\n}\n\n.pr-45 {\n  padding-right: 45px;\n}\n\n.pr-50 {\n  padding-right: 50px;\n}\n\n.pr-55 {\n  padding-right: 55px;\n}\n\n.pr-60 {\n  padding-right: 60px;\n}\n\n.pr-65 {\n  padding-right: 65px;\n}\n\n.pr-70 {\n  padding-right: 70px;\n}\n\n.pr-75 {\n  padding-right: 75px;\n}\n\n.pr-80 {\n  padding-right: 80px;\n}\n\n.pr-85 {\n  padding-right: 85px;\n}\n\n.pr-90 {\n  padding-right: 90px;\n}\n\n.pr-95 {\n  padding-right: 95px;\n}\n\n.pr-100 {\n  padding-right: 100px;\n}\n\n.pr-105 {\n  padding-right: 105px;\n}\n\n.pr-110 {\n  padding-right: 110px;\n}\n\n.pr-115 {\n  padding-right: 115px;\n}\n\n.pr-120 {\n  padding-right: 120px;\n}\n\n.pr-125 {\n  padding-right: 125px;\n}\n\n.pr-130 {\n  padding-right: 130px;\n}\n\n.pr-135 {\n  padding-right: 135px;\n}\n\n.pr-140 {\n  padding-right: 140px;\n}\n\n.pr-145 {\n  padding-right: 145px;\n}\n\n.pr-150 {\n  padding-right: 150px;\n}\n\n.pr-155 {\n  padding-right: 155px;\n}\n\n.pr-160 {\n  padding-right: 160px;\n}\n\n.pr-165 {\n  padding-right: 165px;\n}\n\n.pr-170 {\n  padding-right: 170px;\n}\n\n.pr-175 {\n  padding-right: 175px;\n}\n\n.pr-180 {\n  padding-right: 180px;\n}\n\n.pr-185 {\n  padding-right: 185px;\n}\n\n.pr-190 {\n  padding-right: 190px;\n}\n\n.pr-195 {\n  padding-right: 195px;\n}\n\n.pr-200 {\n  padding-right: 200px;\n}\n\n.container {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.row {\n  --bs-gutter-x: 30px;\n}\n\n.row.g-0 {\n  --bs-gutter-x: 0;\n}\n\n@media (min-width: 1400px) {\n  .container {\n    max-width: 1320px;\n  }\n}\n\n/* <<<<<<<    Declaration   >>>>>>>>> */\n.bg-catkrill {\n  background-color: var(--catkrill);\n}\n\n.bg-prink {\n  background-color: var(--prink);\n}\n\n.bg-light-white-2 {\n  background-color: var(--light-white-2);\n}\n\n.bg-default {\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n.no-after::after {\n  display: none;\n}\n\n.p-relative {\n  position: relative;\n}\n\n.z-index-3 {\n  position: relative;\n  z-index: 3;\n}\n\n.z-index-5 {\n  position: relative;\n  z-index: 5;\n}\n\n.w-60 {\n  width: 60%;\n}\n\n.w-80 {\n  width: 80%;\n}\n\n.w-85 {\n  width: 85%;\n}\n\n.w-90 {\n  width: 90%;\n}\n\n.w-94 {\n  width: 94%;\n}\n\n.gap-30 {\n  gap: 30px;\n}\n\n.modal-backdrop.fade.show {\n  display: none;\n}\n\n/*\n************\n*************************\n02. button\n******************************************************* \n*************************************************************** */\n.btn-1 {\n  display: inline-block;\n  font-size: 18px;\n  font-weight: 500;\n  text-transform: capitalize;\n  color: var(--common-white);\n  background-color: var(--theme-primary);\n  line-height: 27px;\n  padding: 14px 30px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n}\n\n.btn-1 .icon {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.btn-1 .icon {\n  transition: 0.3s;\n}\n\n.btn-1:focus {\n  color: var(--common-white-two);\n}\n\n.btn-1:hover {\n  background-color: var(--light-white);\n  border: 1px solid var(--theme-primary);\n  color: var(--common-black);\n}\n\n.btn-1:hover .icon {\n  color: var(--common-black) !important;\n}\n\n.btn-2 {\n  display: inline-block;\n  font-size: 18px;\n  font-weight: 400;\n  text-transform: capitalize;\n  color: var(--common-white);\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n  line-height: 27px;\n  padding: 12px 30px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  transition: 0.3s;\n}\n\n.btn-2 .icon {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.btn-2 .icon svg * {\n  transition: 0.3s;\n}\n\n.btn-2:hover,\n.btn-2:focus {\n  background: linear-gradient(80deg, #fa5252 0%, #e12a72 100%);\n  border: 1px solid linear-gradient(97deg, rgb(201, 93, 93) 0%, rgb(221, 36, 118) 100%);\n  color: var(--light-white);\n  transform: translateY(-2px);\n}\n\n.btn-2:hover .icon svg * {\n  fill: var(--light-white);\n}\n\n.dark-btn {\n  display: inline-block;\n  width: 26px;\n  height: 26px;\n  line-height: 23px;\n  text-align: center;\n  background-color: var(--common-white);\n  border-radius: 50%;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);\n  margin-right: 10px;\n}\n\n.dark-btn:hover {\n  background-color: var(--theme-secondary);\n}\n\n.home-3 .dark-btn {\n  width: 50px;\n  height: 50px;\n  line-height: 48px;\n  cursor: pointer;\n}\n\n.home-1 .dark-btn {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.home-1 .dark-btn:hover {\n  background-color: #1b74e4;\n}\n\n.dark-btn.dark-btn-2 {\n  width: 45px;\n  height: 45px;\n  display: flex;\n  margin-right: 0;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.dark-btn.dark-btn-2:hover img {\n  transform: 0.3s;\n}\n\n.dark-btn.dark-btn-2:hover img {\n  filter: invert(1);\n}\n\n.form-btn {\n  font-size: 16px;\n  font-weight: 500;\n  display: inline-block;\n  text-transform: capitalize;\n  color: #1a1a1a;\n  height: 50px;\n  width: 133px;\n  border: 1px solid #44566c;\n  border-radius: 12px;\n  background-color: var(--light-white-2);\n}\n\n.form-btn:hover {\n  background-color: var(--theme-primary);\n  border-color: var(--theme-primary);\n  color: #fff;\n}\n\n.page-wrapper-2 .form-btn:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n  border-color: transparent;\n}\n\n.home-3 .form-btn:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n  border-color: transparent;\n}\n\n/*\n************\n*************************\n03. page\n******************************************************* \n*************************************************************** */\n.page-wrapper {\n  height: 100vh;\n  width: 100vw;\n  display: block;\n  background-position: center center;\n  background-size: cover;\n  /* position: fixed; */\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-top: 0px;\n  padding-bottom: 120px;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .page-wrapper {\n    padding-top: 120px;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px),\nonly screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .page-wrapper {\n    padding-top: 120px;\n  }\n}\n\n.page-wrapper.page-wrapper-2 {\n  padding-top: 30px;\n  padding-bottom: 60px;\n}\n\n.page-wrapper.page-wrapper-2.inner-page {\n  padding-bottom: 0;\n}\n\n.bostami-page-title-wrap p {\n  max-width: 632px;\n}\n\n.page-title {\n  position: relative;\n  display: inline-block;\n  font-family: Roboto Slab, serif;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px),\nlg,\nonly screen and (min-width: 768px) and (max-width: 991px) {\n  .page-title {\n    font-size: 36px;\n  }\n}\n\n@media (max-width: 767px) {\n  .page-title {\n    font-size: 32px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .page-title {\n    font-size: 34px;\n  }\n}\n\n.page-title::after {\n  content: \"\";\n  position: absolute;\n  width: 200px;\n  height: 3px;\n  background-color: var(--theme-primary);\n  left: 122%;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 5px;\n  margin-bottom: 30px;\n}\n\n@media (max-width: 767px) {\n  .page-title::after {\n    width: 70%;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .page-title::after {\n    width: 100%;\n  }\n}\n\n.bostami-page-content-wrap {\n  background-color: var(--common-white);\n  border-radius: 20px;\n}\n\n.bostami-section-title-wrap .section-title {\n  margin-bottom: 0;\n  font-weight: 500;\n}\n\n.bostami-section-title-wrap .section-title img {\n  margin-right: 6px;\n  margin-top: -5px;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px),\nonly screen and (min-width: 992px) and (max-width: 1199px),\nmd,\n(max-width: 767px) {\n  .bostami-section-title-wrap .section-title {\n    font-size: 24px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .section-wrapper:is(.pl-60) {\n    padding-left: 40px;\n  }\n}\n\n@media (max-width: 767px) {\n  .section-wrapper:is(.pl-60) {\n    padding-left: 20px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .section-wrapper:is(.pr-60) {\n    padding-right: 40px;\n  }\n}\n\n@media (max-width: 767px) {\n  .section-wrapper:is(.pr-60) {\n    padding-right: 20px;\n  }\n}\n\n.bostami-page-area .bostami-page-wrap {\n  background: #fff;\n  border-radius: 20px;\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px),\nonly screen and (min-width: 768px) and (max-width: 991px) {\n  .bostami-page-area .bostami-page-wrap:is(.pl-80) {\n    padding-left: 40px;\n  }\n}\n\n@media (max-width: 767px) {\n  .bostami-page-area .bostami-page-wrap:is(.pl-80) {\n    padding-left: 20px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .bostami-page-area .bostami-page-wrap:is(.pl-80) {\n    padding-left: 30px;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px),\nonly screen and (min-width: 768px) and (max-width: 991px) {\n  .bostami-page-area .bostami-page-wrap:is(.pr-80) {\n    padding-right: 40px;\n  }\n}\n\n@media (max-width: 767px) {\n  .bostami-page-area .bostami-page-wrap:is(.pr-80) {\n    padding-right: 20px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .bostami-page-area .bostami-page-wrap:is(.pr-80) {\n    padding-right: 30px;\n  }\n}\n\n.bostami-page-area .bostami-parsonal-info-contact .title {\n  font-weight: 500;\n}\n\n.bostami-page-area .section-title {\n  font-weight: 500;\n}\n\n.bostami-page-area .bostami-parsonal-info-title {\n  font-weight: 500;\n  margin-bottom: 11px;\n}\n\n.bostami-page-area .page-title::after {\n  background: rgb(250, 82, 82);\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n@media (max-width: 767px) {\n  .bostami-page-area .page-title::after {\n    width: 40%;\n  }\n}\n\n.bostami-page-area .bostami-parsonal-info-img {\n  width: 100%;\n  height: 400px;\n  margin: 0;\n  border-radius: 30px;\n  margin-bottom: 80px;\n}\n\n.bostami-page-area .bostami-parsonal-info-contact {\n  background: transparent;\n  padding: 20px 0px;\n  margin-top: -13px;\n}\n\n.footer-wrap span {\n  display: block;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 28px;\n  color: #44566c;\n  padding: 20px 0;\n}\n\n.home-3 .page-title::after {\n  /* background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%); */\n  background-color: var(--theme-primary);\n}\n\n.page-wrapper.home-3 {\n  padding-top: 20px;\n  padding-bottom: 40px;\n}\n\n.home-3 .bostami-header-area {\n  margin-bottom: 150px;\n  background-color: transparent;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px),\nonly screen and (min-width: 992px) and (max-width: 1199px),\nonly screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .home-3 .bostami-header-area {\n    margin-bottom: 40px;\n  }\n}\n\n.home-3 .bostami-header-area .bostami-header-wrap {\n  background-color: transparent;\n}\n\n.page-wrapper.home-1 {\n  padding-top: 50px;\n  padding-bottom: 60px;\n}\n\n/*\n************\n*************************\n04. header\n******************************************************* \n*************************************************************** */\n.bostami-header-wrap {\n  background: var(--light-white);\n  padding: 20px;\n  border-radius: 12px;\n}\n\n.bostami-header-menu-btn {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.bostami-header-menu-btn .menu-btn {\n  position: relative;\n  display: inline-flex;\n  width: 26px;\n  height: 26px;\n  background: linear-gradient(180deg, #fa5252 0%, #e12a72 100%);\n  border-radius: 50%;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: 1s;\n  overflow: hidden;\n}\n\n.bostami-header-menu-btn .menu-btn:hover {\n  background: linear-gradient(180deg, #1b74e4 0%, #1b74e4 100%);\n}\n\n.menu-btn span {\n  position: absolute;\n  width: 12px;\n  height: 2px;\n  background-color: var(--common-white-two);\n  border-radius: 2px;\n  transition: 0.5s;\n}\n\n.menu-btn span:nth-child(1) {\n  transform: translateY(-5px);\n}\n\n.menu-btn span:nth-child(2) {\n  transform: translateY(5px);\n}\n\n.menu-btn.active {\n  background: linear-gradient(180deg, #1b74e4 0%, #1b74e4 100%);\n}\n\n.menu-btn.active span:nth-child(1) {\n  transform: rotate(45deg);\n}\n\n.menu-btn.active span:nth-child(2) {\n  transform: rotate(-45deg);\n}\n\n.menu-btn.active span:nth-child(3) {\n  transform: translateX(30px);\n}\n\n.mobile-menu-wrap {\n  position: relative;\n}\n\n.mobile-menu-wrap .mobile-menu {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  transform: scaleY(0);\n  transform-origin: top;\n  z-index: 5;\n  transition: 0.5s;\n}\n\n.mobile-menu-wrap .mobile-menu .mean-bar {\n  background-color: var(--common-white);\n  border-radius: 12px;\n  box-shadow: 0px 6px 6px rgba(238, 238, 238, 0.2);\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav {\n  margin-top: 0;\n  background-color: var(--common-white);\n}\n\n.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a {\n  border: none;\n  font-size: 13px;\n  text-transform: capitalize;\n  font-weight: 500;\n  color: var(--body-text);\n  padding: 5px 70px;\n}\n\n@media (max-width: 767px) {\n  .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a {\n    padding: 5px 0px;\n  }\n}\n\n.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a span {\n  display: inline-block;\n}\n\n.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a span svg {\n  width: 16px !important;\n  margin-right: 8px;\n}\n\n.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a:hover {\n  color: var(--theme-secondary);\n}\n\n.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a:hover span svg * {\n  fill: var(--theme-secondary);\n}\n\n@media (max-width: 767px) {\n  .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li {\n    padding: 0px 40px;\n  }\n}\n\n.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a {\n  color: var(--theme-secondary);\n}\n\n.mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a span svg * {\n  fill: var(--theme-secondary);\n}\n\n.mobile-menu.active {\n  transform: scaleY(1);\n}\n\n.bastami-main-menu ul li {\n  background-color: var(--light-white);\n  border-radius: 12px;\n  width: 84px;\n  height: 84px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  transition: 0.3s;\n}\n\n.bastami-main-menu ul li:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.bastami-main-menu ul li a {\n  display: block;\n  font-size: 13px;\n  text-transform: capitalize;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.bastami-main-menu ul li a span {\n  display: block;\n  margin-bottom: 12px;\n}\n\n.bastami-main-menu ul li:is(.active) {\n  background-color: var(--theme-primary);\n}\n\n.bastami-main-menu ul li:is(.active) a {\n  color: var(--common-white);\n}\n\n.bastami-main-menu ul li:is(.active) a span svg * {\n  fill: var(--common-white);\n}\n\n.bastami-main-menu ul li:is(.active) a span img {\n  filter: brightness(5);\n}\n\n.bastami-main-menu ul li:hover {\n  background-color: var(--theme-primary);\n}\n\n.bastami-main-menu ul li:hover a {\n  color: var(--common-white);\n}\n\n.bastami-main-menu ul li:hover a span svg * {\n  fill: var(--common-white);\n}\n\n.bastami-main-menu ul li:hover a span img {\n  filter: brightness(5);\n}\n\n.dark-theme .bastami-main-menu ul li a span img {\n  filter: invert(0.8) !important;\n}\n\n.dark-theme .bastami-main-menu ul li.active a span img {\n  filter: brightness(5) !important;\n}\n\n.dark-theme .home-1 .bastami-main-menu ul li:hover a span img,\n.dark-theme .home-3 .bastami-main-menu ul li:hover a span img {\n  filter: brightness(5) !important;\n}\n\n.dark-theme .page-wrapper-2 .bastami-main-menu ul li:hover a span img {\n  filter: invert(1) !important;\n}\n\n.bastami-main-menu ul li a span img {\n  width: 20px;\n}\n\n.bastami-main-menu ul li.active:first-child a span img {\n  filter: invert(1) !important;\n}\n\n.bastami-main-menu ul li:first-child:hover a span img {\n  filter: invert(1);\n}\n\n.header-right-flex {\n  display: flex;\n  justify-content: right;\n  align-items: center;\n}\n\n.main-style-2 {\n  background-color: transparent;\n}\n\n.main-style-2 .bostami-main-menu-wrap {\n  width: unset;\n  background: transparent;\n  border-radius: 0px;\n  padding: 0;\n  position: unset;\n  top: unset;\n  display: inline-block;\n}\n\n.main-style-2 .bostami-main-menu-wrap .bastami-main-menu {\n  display: inline-block;\n}\n\n.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul {\n  display: inline-block;\n}\n\n.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li {\n  display: inline-block;\n  background-color: var(--light-white);\n  border-radius: 8px;\n  width: unset;\n  height: unset;\n  text-align: unset;\n  transition: 0.3s;\n  margin-bottom: 0;\n}\n\n.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li:not(:first-child) {\n  margin-left: 16px;\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li:not(:first-child) {\n    margin-left: 5px;\n  }\n}\n\n.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a {\n  background: #fff;\n  border-radius: 8px;\n  padding: 0px 19px;\n  transition: 0.3s;\n  height: 40px;\n  line-height: 40px;\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a {\n    padding: 0px 10px;\n  }\n}\n\n.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a:hover {\n  background: rgb(250, 82, 82);\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a span {\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 5px;\n}\n\n.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a span svg {\n  width: 20px;\n}\n\n.main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li:is(.active) a {\n  background: rgb(250, 82, 82);\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.bostami-header-logo {\n  flex: 0 0 auto;\n}\n\n.menu-btn.menu-btn-2 {\n  width: 45px;\n  height: 45px;\n  margin-left: 20px;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .menu-btn.menu-btn-2 {\n    margin-bottom: -8px;\n  }\n}\n\n.page-wrapper.page-wrapper-2 .bostami-header-logo .site-logo img {\n  width: 150px;\n}\n\n@media (max-width: 767px) {\n  .page-wrapper.page-wrapper-2 .bostami-header-logo .site-logo img {\n    width: 110px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .page-wrapper.page-wrapper-2 .bostami-header-logo .site-logo img {\n    width: 150px;\n  }\n}\n\n.dark-theme .page-wrapper.page-wrapper-2 {\n  background-image: url(\"../img/bg/page-bg-dark-2.jpg\") !important;\n}\n\n.home-3 .text-right {\n  text-align: right;\n  margin-bottom: 40px;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .home-3 .text-right {\n    margin-bottom: 0;\n  }\n}\n\n.home-3 .bostami-main-menu-wrap {\n  width: unset;\n  position: unset;\n  display: inline-block;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .home-3 .bostami-main-menu-wrap {\n    display: none;\n  }\n}\n\n.home-3 .bastami-main-menu ul li {\n  display: inline-flex;\n  margin-bottom: 0;\n}\n\n.home-3 .bastami-main-menu ul li:not(:first-child) {\n  margin-left: 16px;\n}\n\n.home-3 .bastami-main-menu ul li:hover {\n  /* background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%); */\n  background-color: var(--theme-primary);\n}\n\n.home-3 .bastami-main-menu ul li:is(.active) {\n  /* background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%); */\n  background-color: var(--theme-primary);\n}\n\n.inner-page .bostami-header-wrap {\n  padding: 20px 0;\n}\n\n.home-3 .bostami-header-menu-btn .menu-btn {\n  width: 40px;\n  height: 40px;\n}\n\n.home-3 .menu-btn.active {\n  /* background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%); */\n  background-color: var(--theme-primary);\n}\n\n.home-1 .bostami-header-area {\n  margin-bottom: 205px;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px),\nonly screen and (min-width: 992px) and (max-width: 1199px),\nonly screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .home-1 .bostami-header-area {\n    margin-bottom: 50px;\n  }\n}\n\n.home-1 .bostami-header-wrap {\n  margin-left: -112px;\n  margin-right: -70px;\n  background-color: transparent;\n}\n\n@media only screen and (min-width: 1400px) and (max-width: 1599px) {\n  .home-1 .bostami-header-wrap {\n    margin-left: -50px;\n    margin-right: -40px;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px),\nonly screen and (min-width: 992px) and (max-width: 1199px),\nonly screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .home-1 .bostami-header-wrap {\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n}\n\n.home-1 .bostami-header-menu-btn .menu-btn {\n  width: 40px;\n  height: 40px;\n}\n\n@media (min-width: 1800px),\nonly screen and (min-width: 1600px) and (max-width: 1799px),\nonly screen and (min-width: 1400px) and (max-width: 1599px) {\n  .home-1 .bostami-header-menu-btn .menu-btn {\n    display: none;\n  }\n}\n\n.home-1 .bostami-header-menu-btn .menu-btn {\n  background: #1b74e4;\n}\n\n.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a {\n  color: #1b74e4;\n}\n\n.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:hover a {\n  color: #1b74e4;\n}\n\n.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:hover a span img {\n  filter: saturate(20.5);\n}\n\n.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a span img {\n  filter: saturate(20.5);\n}\n\n.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li a:hover span svg * {\n  fill: #1b74e4;\n}\n\n.home-1 .mobile-menu-wrap .mobile-menu .mean-bar .mean-nav ul li:is(.active) a span svg * {\n  fill: #1b74e4;\n}\n\n/*\n************\n*************************\n05. parsonal info\n******************************************************* \n*************************************************************** */\n.bostami-parsonal-info-area {\n  width: 400px;\n  border-radius: 20px;\n  background-color: var(--common-white);\n  text-align: center;\n  padding: 40px 30px;\n  margin-left: -100px;\n  position: sticky;\n  top: 100px;\n}\n\n@media only screen and (min-width: 1400px) and (max-width: 1599px) {\n  .bostami-parsonal-info-area {\n    width: 340px;\n    margin-left: -40px;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .bostami-parsonal-info-area {\n    width: 100%;\n    margin-left: 0px;\n    padding: 30px 15px;\n    top: -40px;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px),\nonly screen and (min-width: 768px) and (max-width: 991px) {\n  .bostami-parsonal-info-area {\n    width: 100%;\n    margin-left: 0px;\n    margin-bottom: 30px;\n    top: -40px;\n  }\n}\n\n@media (max-width: 767px) {\n  .bostami-parsonal-info-area {\n    width: 100%;\n    margin-left: 0px;\n    margin-bottom: 30px;\n    padding: 40px 20px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .bostami-parsonal-info-area {\n    padding: 40px 30px;\n  }\n}\n\n.bostami-parsonal-info-img {\n  width: 240px;\n  height: 240px;\n  border-radius: 20px;\n  overflow: hidden;\n  margin: auto;\n  margin-bottom: 21px;\n  margin-top: -180px;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .bostami-parsonal-info-img {\n    width: 210px;\n    height: 210px;\n    margin-top: 0px;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px),\nonly screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .bostami-parsonal-info-img {\n    margin-top: 0px;\n  }\n}\n\n.bostami-parsonal-info-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.bostami-parsonal-info-name {\n  font-size: 26px;\n  text-transform: capitalize;\n  font-weight: 500;\n  color: var(--common-black);\n  font-family: \"Roboto Slab\", serif;\n  margin-bottom: 8px;\n}\n\n.btn-2.circle {\n  border-radius: 30px;\n}\n\n.dark-theme .btn-2.circle {\n  color: #fff;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .bostami-parsonal-info-name {\n    font-size: 20px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .bostami-parsonal-info-name {\n    font-size: 22px;\n  }\n}\n\n.bostami-parsonal-info-bio {\n  font-size: 14px;\n  display: inline-block;\n  font-weight: 500;\n  text-transform: capitalize;\n  color: var(--common-black);\n  font-family: \"Poppins\", sans-serif;\n  background-color: var(--light-white);\n  border-radius: 5px;\n  padding: 4px 20px;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px),\nonly screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .bostami-parsonal-info-bio {\n    font-size: 14px;\n  }\n}\n\n.bostami-parsonal-info-social-link li {\n  display: inline-block;\n  margin: 0 4px;\n}\n\n.bostami-parsonal-info-social-link li a {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background-color: var(--light-white);\n  text-align: center;\n  line-height: 40px;\n}\n\n.bostami-parsonal-info-social-link li a:hover {\n  background-color: var(--theme-primary);\n}\n\n.bostami-parsonal-info-social-link li a:hover {\n  color: var(--common-white-two) !important;\n}\n\n.bostami-parsonal-info-social-link li a {\n  color: #1c9cea;\n  font-size: 20px;\n}\n\n.bostami-parsonal-info-contact {\n  background-color: var(--light-white);\n  border-radius: 16px;\n  text-align: left;\n  padding: 20px 30px;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .bostami-parsonal-info-contact {\n    padding: 20px 15px;\n  }\n}\n\n@media (max-width: 767px) {\n  .bostami-parsonal-info-contact {\n    padding: 20px 15px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .bostami-parsonal-info-contact {\n    padding: 20px 30px;\n  }\n}\n\n.bostami-parsonal-info-contact-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.bostami-parsonal-info-contact-item:not(:first-child) {\n  border-top: 1px solid #e3e3e3;\n}\n\n.bostami-parsonal-info-contact-item .icon {\n  flex: 0 0 auto;\n  display: inline-block;\n  width: 44px;\n  height: 44px;\n  background-color: var(--common-white);\n  border-radius: 8px;\n  text-align: center;\n  line-height: 44px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);\n  transition: 0.3s;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .bostami-parsonal-info-contact-item .icon {\n    width: 35px;\n    height: 35px;\n    line-height: 35px;\n    transition: 0.3s;\n  }\n}\n\n.bostami-parsonal-info-contact-item .icon svg * {\n  transition: 0.3s;\n}\n\n.bostami-parsonal-info-contact-item .icon:hover {\n  background-color: var(--theme-primary);\n  color: var(--common-white-two) !important;\n}\n\n.bostami-parsonal-info-contact-item .icon:hover {}\n\n.bostami-parsonal-info-contact-item .text {\n  display: inline-block;\n}\n\n.bostami-parsonal-info-contact-item .text span {\n  display: block;\n  font-size: 12px;\n  line-height: 18px;\n  text-transform: capitalize;\n  font-weight: 400;\n  margin-bottom: 3px;\n}\n\n.bostami-parsonal-info-contact-item .text p {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  color: var(--common-black);\n  text-transform: capitalize;\n  margin-bottom: 0;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .bostami-parsonal-info-contact-item .text p {\n    font-size: 14px;\n  }\n}\n\n.bostami-parsonal-info-area.bostami-parsonal-info-2-area {\n  background-color: transparent;\n  width: unset;\n  margin-left: 0;\n  position: unset;\n}\n\n@media (min-width: 1920px) {\n  .bostami-parsonal-info-area.bostami-parsonal-info-2-area {\n    margin-top: 50px;\n  }\n}\n\n.bostami-parsonal-info-area.bostami-parsonal-info-2-area .bostami-parsonal-info-img {\n  width: 280px;\n  height: 280px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin: auto;\n  margin-bottom: 21px;\n  margin-top: 0;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .bostami-parsonal-info-area.bostami-parsonal-info-2-area .bostami-parsonal-info-img {\n    width: 240px;\n    height: 240px;\n  }\n}\n\n.bostami-parsonal-info-area.bostami-parsonal-info-2-area .bostami-parsonal-info-bio {\n  background: transparent;\n  color: #7b7b7b;\n}\n\n.bostami-parsonal-info-area.bostami-parsonal-info-2-area .bostami-parsonal-info-social-link li a:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.bostami-parsonal-info-area.about-2-page {\n  width: 100%;\n  margin-left: 0;\n  background: transparent;\n  position: unset;\n  padding: 0;\n}\n\n.bostami-parsonal-info-area.about-2-page .bostami-page-title-wrap {\n  text-align: left;\n}\n\n.bostami-parsonal-info-area.about-2-page .bostami-parsonal-info-img {\n  width: 100%;\n  height: 400px;\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.page-wrapper-2 .bostami-parsonal-info-contact-item .icon:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.home-3 .bostami-parsonal-info-area {\n  width: 100%;\n  margin-left: 0;\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .home-3 .bostami-parsonal-info-contact {\n    padding: 20px 10px;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .home-3 .bostami-parsonal-info-contact-item .text p {\n    font-size: 14px;\n  }\n}\n\n.home-3 .bostami-parsonal-info-social-link li a:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.home-3 .bostami-parsonal-info-contact-item .icon:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n/*\n************\n*************************\n06. client\n******************************************************* \n*************************************************************** */\n.bostami-client {\n  padding-top: 40px;\n  padding-bottom: 70px;\n  background-color: var(--light-white-2);\n}\n\n.bostami-client-slider-logo {\n  padding: 0px 15px;\n  height: 62px;\n}\n\n.bostami-main-menu-wrap {\n  width: 144px;\n  background: white;\n  border-radius: 16px;\n  padding: 30px;\n  position: sticky;\n  top: -45px;\n}\n\n@media only screen and (min-width: 1400px) and (max-width: 1599px) {\n  .bostami-main-menu-wrap {\n    width: 120px;\n    padding: 18px;\n  }\n}\n\n.bostami-client-slider .swiper-slide {\n  text-align: center !important;\n}\n\n/*\n************\n*************************\n07. what do\n******************************************************* \n*************************************************************** */\n.bostami-what-do-item {\n  border-radius: 12px;\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n  padding-bottom: 15px;\n  margin-bottom: 30px;\n}\n\n@media (max-width: 767px) {\n  .bostami-what-do-item {\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .bostami-what-do-item {\n    flex-wrap: nowrap;\n  }\n}\n\n.bostami-what-do-item .text .title {\n  margin-bottom: 10px;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px),\nlg,\nonly screen and (min-width: 768px) and (max-width: 991px) {\n  .bostami-what-do-item .text .title {\n    font-size: 22px;\n  }\n}\n\n@media (max-width: 767px) {\n  .bostami-what-do-item .text .title {\n    font-size: 22px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .bostami-what-do-item .text .title {\n    font-size: 24px;\n  }\n}\n\n.bostami-what-do-item .text p {\n  margin-bottom: 0;\n  line-height: 30px;\n}\n\n.bostami-page-wrap .client-2-wrap {\n  border-radius: 20px;\n  padding-left: 25px;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .page-wrapper-2 .bostami-what-do-item {\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .home-3 .bostami-what-do-item {\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .home-3 .bostami-what-do-item .text .title {\n    font-size: 20px;\n  }\n}\n\n/*\n************\n*************************\n08. resume\n******************************************************* \n*************************************************************** */\n@media only screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .bostami-card-wrap {\n    margin-bottom: 50px;\n  }\n}\n\n.bostami-card-item {\n  padding: 20px;\n  border-radius: 12px;\n  padding-top: 25px;\n}\n\n.bostami-card-item .card-subtitle {\n  display: block;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1;\n  margin-bottom: 9px;\n}\n\n.bostami-card-item .card-title {\n  font-size: 18px;\n  font-weight: 400;\n  color: var(--heading-black);\n  margin-bottom: 4px;\n}\n\n.bostami-card-item .card-title span {\n  color: var(--body-text);\n}\n\n.bostami-card-item .card-text {\n  font-size: 16px;\n  font-weight: 400;\n  margin-bottom: 0;\n}\n\n.skill-bar-item .title-wrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 7px;\n}\n\n.skill-bar-item .title-wrap .title {\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--body-text);\n  margin-bottom: 0;\n}\n\n.skill-bar-item .title-wrap .count {\n  display: block;\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--body-text);\n}\n\n.skill-section {\n  background-color: var(--light-white-2);\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .skill-bar-wrap {\n    margin-bottom: 50px;\n  }\n}\n\n.progress-bar-wrap {\n  height: 6px;\n  background: #edf2f2;\n  border-radius: 6px;\n  overflow: inherit;\n}\n\n.progress-line {\n  height: 100%;\n  border-radius: inherit;\n}\n\n.progress-bg-1 {\n  background-color: #ff6464;\n}\n\n.progress-bg-2 {\n  background-color: #9272d4;\n}\n\n.progress-bg-3 {\n  background-color: #5185d4;\n}\n\n.progress-bg-4 {\n  background-color: #ca56f2;\n}\n\n.knowledeges-item-wrap .gk-item {\n  display: inline-block;\n  font-size: 15px;\n  font-weight: 400;\n  background: #edf2f2;\n  border-radius: 8px;\n  padding: 5px 20px;\n  margin-right: 10px;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 767px) {\n  .bostami-resume-page {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .bostami-resume-page {\n    padding-left: 60px;\n    padding-right: 60px;\n  }\n}\n\n@media (max-width: 767px) {\n  .section-wrap {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .section-wrap {\n    padding-left: 60px;\n    padding-right: 60px;\n  }\n}\n\n.page-wrapper-2 .border-redius-20 {\n  border-radius: 20px;\n}\n\n/*\n************\n*************************\n09. portfolio\n******************************************************* \n*************************************************************** */\n.fillter-btn-wrap {\n  text-align: right;\n}\n\n@media (max-width: 767px) {\n  .fillter-btn-wrap {\n    text-align: left;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .fillter-btn-wrap {\n    text-align: right;\n  }\n}\n\n.fillter-btn-wrap .fillter-btn {\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: capitalize;\n  display: inline-block;\n  padding: 0 18px;\n  cursor: pointer;\n}\n\n.fillter-btn-wrap .fillter-btn:hover {\n  color: var(--theme-primary);\n}\n\n.fillter-btn-wrap .fillter-btn:is(.is-checked) {\n  color: var(--theme-primary);\n}\n\n.fillter-item {\n  display: inline-block;\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.fillter-item .img {\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 17px;\n  display: block;\n  transition: 0.1s;\n}\n\n.fillter-item:hover img {\n  transform: scale(1.1);\n}\n\n.fillter-item .item-subtitle {\n  display: block;\n  font-size: 12px;\n  font-weight: 400;\n  text-transform: capitalize;\n}\n\n.fillter-item .item-title {\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: capitalize;\n  margin-bottom: 0;\n}\n\n.fillter-item .item-title:hover {\n  color: var(--theme-primary);\n}\n\n.isotop-item,\n.grid-sizer {\n  width: 50%;\n  padding: 0 10px;\n}\n\n@media (max-width: 767px) {\n\n  .isotop-item,\n  .grid-sizer {\n    width: 100%;\n  }\n}\n\n.isotop-item>div,\n.isotop-item>div {\n  margin-bottom: 20px;\n}\n\n.portfolio-modal-box {\n  position: fixed;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.4509803922);\n}\n\n.portfolio-modal-box .modal-dialog {\n  max-width: 850px;\n  height: 90vh;\n  overflow: hidden;\n  background-color: white;\n  padding: 30px;\n  border-radius: 20px;\n  border: none;\n  /* width */\n  /* Track */\n  /* Handle */\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .portfolio-modal-box .modal-dialog {\n    max-width: 660px;\n  }\n}\n\n@media (max-width: 767px) {\n  .portfolio-modal-box .modal-dialog {\n    max-width: 95%;\n    padding: 10px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .portfolio-modal-box .modal-dialog {\n    max-width: 95%;\n    padding: 30px;\n  }\n}\n\n.portfolio-modal-box .modal-dialog ::-webkit-scrollbar {\n  width: 10px;\n}\n\n.portfolio-modal-box .modal-dialog ::-webkit-scrollbar-track {\n  background-color: #e9e3e3;\n  border-radius: 10px;\n}\n\n.portfolio-modal-box .modal-dialog ::-webkit-scrollbar-thumb {\n  background: #9c9fa1;\n  border-radius: 10px;\n}\n\n.portfolio-modal-box .modal-dialog .modal-content {\n  overflow-x: hidden;\n  overflow-y: scroll;\n  height: 100%;\n  position: relative;\n  padding-right: 15px;\n  border-radius: 0;\n  border: none;\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-header {\n  display: inline-block;\n  position: fixed;\n  right: 25%;\n  top: 5%;\n  z-index: 18;\n  border-bottom: 0;\n  padding: 0;\n}\n\n@media (min-width: 1800px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-header {\n    right: 25%;\n    top: 3%;\n  }\n}\n\n@media only screen and (min-width: 1600px) and (max-width: 1799px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-header {\n    right: 18%;\n    top: 8%;\n  }\n}\n\n@media only screen and (min-width: 1400px) and (max-width: 1599px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-header {\n    right: 19%;\n    top: 4%;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-header {\n    right: 8%;\n    top: 10%;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-header {\n    right: 3%;\n    top: 2%;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-header {\n    right: 1%;\n    top: 3%;\n  }\n}\n\n@media (max-width: 767px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-header {\n    right: 1%;\n    top: 4%;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-header {\n    right: 1%;\n    top: 4%;\n  }\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-header .close {\n  background: transparent;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  font-size: 20px;\n  color: white;\n  border-color: white;\n  border: 1px solid;\n  line-height: 38px;\n  transition: 0.3s;\n}\n\n@media (max-width: 767px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-header .close {\n    border-color: #e12a72;\n    color: #e12a72;\n  }\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-header .close:hover {\n  rotate: 90deg;\n  border-color: #e12a72;\n  color: #e12a72;\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-body .h1-modal-img {\n  border-radius: 15px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-body .blog-title {\n  font-size: 28px;\n  text-align: center;\n  color: #fa5252;\n  margin-bottom: 35px;\n}\n\n@media (max-width: 767px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-body .blog-title {\n    margin-top: 20px;\n    font-size: 22px;\n  }\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table {\n  margin-bottom: 20px;\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text {\n  font-size: 18px;\n  font-weight: 400;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 767px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text {\n    font-size: 14px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text {\n    font-size: 16px;\n  }\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text i {\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text span {\n  font-weight: 500;\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text a {\n  display: inline-block;\n  font-weight: 500;\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-body .portfolio-modal-table .portfolio-modal-table-text a:hover {\n  color: #fa5252;\n}\n\n.portfolio-modal-box .modal-dialog .modal-content .modal-body .h1-modal-paragraph {\n  margin-bottom: 30px;\n}\n\n.page-wrapper-2 .isotop-item,\n.page-wrapper-2 .grid-sizer {\n  width: 33.33%;\n  padding: 0 10px;\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n\n  .page-wrapper-2 .isotop-item,\n  .page-wrapper-2 .grid-sizer {\n    width: 33.33%;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n  .page-wrapper-2 .isotop-item,\n  .page-wrapper-2 .grid-sizer {\n    width: 50%;\n  }\n}\n\n@media (max-width: 767px) {\n\n  .page-wrapper-2 .isotop-item,\n  .page-wrapper-2 .grid-sizer {\n    width: 100%;\n  }\n}\n\n.page-wrapper-2 .fillter-btn-wrap .fillter-btn:hover {\n  color: #fa5252;\n}\n\n.page-wrapper-2 .fillter-btn-wrap .fillter-btn.is-checked {\n  color: #fa5252;\n}\n\n.page-wrapper-2 .fillter-item .item-title:hover {\n  color: #fa5252;\n}\n\n.home-3 .fillter-btn-wrap .fillter-btn:is(.is-checked) {\n  color: #fa5252;\n}\n\n.home-3 .fillter-btn-wrap .fillter-btn:hover {\n  color: #fa5252;\n}\n\n.home-3 .fillter-item .item-title:hover {\n  color: #fa5252;\n}\n\n/*\n************\n*************************\n10. blog\n******************************************************* \n*************************************************************** */\n.blog-slider-single {\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 30px;\n}\n\n.blog-slider-single .img {\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 18px;\n  display: block;\n}\n\n.blog-slider-single .img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.blog-slider-single:hover img {\n  transform: scale(1.1);\n}\n\n.blog-slider-single .blog-meta span {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: capitalize;\n  margin-right: 5px;\n}\n\n.blog-slider-single .blog-meta .blog-cetagory {\n  position: relative;\n  padding-left: 12px;\n}\n\n.blog-slider-single .blog-meta .blog-cetagory::after {\n  content: \"\";\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background-color: var(--body-text);\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.blog-slider-single .blog-title {\n  font-size: 18px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.blog-slider-single .blog-title:hover {\n  color: var(--theme-primary);\n}\n\n.blog-slider-wrap .blog-progation {\n  text-align: center;\n}\n\n.blog-slider-wrap .blog-progation span {\n  width: 12px;\n  height: 12px;\n  background-color: transparent;\n  border: 1px solid var(--theme-primary) !important;\n  margin: 0px 5px !important;\n  opacity: 1;\n}\n\n.blog-slider-wrap .blog-progation span:is(.swiper-pagination-bullet-active) {\n  background-color: var(--theme-primary);\n}\n\n.h1-modal-box {\n  position: fixed;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.4509803922);\n}\n\n.h1-modal-box .modal-dialog {\n  max-width: 850px;\n  height: 90vh;\n  overflow: hidden;\n  background-color: white;\n  padding: 30px;\n  border-radius: 20px;\n  border: none;\n  /* width */\n  /* Track */\n  /* Handle */\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .h1-modal-box .modal-dialog {\n    max-width: 660px;\n  }\n}\n\n@media (max-width: 767px) {\n  .h1-modal-box .modal-dialog {\n    max-width: 95%;\n    padding: 10px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .h1-modal-box .modal-dialog {\n    max-width: 95%;\n    padding: 30px;\n  }\n}\n\n.h1-modal-box .modal-dialog ::-webkit-scrollbar {\n  width: 10px;\n}\n\n.h1-modal-box .modal-dialog ::-webkit-scrollbar-track {\n  background-color: #e9e3e3;\n  border-radius: 10px;\n}\n\n.h1-modal-box .modal-dialog ::-webkit-scrollbar-thumb {\n  background: #9c9fa1;\n  border-radius: 10px;\n}\n\n.h1-modal-box .modal-dialog .modal-content {\n  overflow-x: hidden;\n  overflow-y: scroll;\n  height: 100%;\n  position: relative;\n  padding-right: 15px;\n  border-radius: 0;\n  border: none;\n}\n\n.modal-header {\n  display: inline-block;\n  position: fixed;\n  right: 25%;\n  top: 3%;\n  z-index: 18;\n  border-bottom: 0;\n  padding: 0;\n}\n\n@media (min-width: 1800px) {\n  .modal-header {\n    right: 25%;\n    top: 3%;\n  }\n}\n\n@media only screen and (min-width: 1600px) and (max-width: 1799px) {\n  .modal-header {\n    right: 18%;\n    top: 8%;\n  }\n}\n\n@media only screen and (min-width: 1400px) and (max-width: 1599px) {\n  .modal-header {\n    right: 18%;\n    top: 5%;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .modal-header {\n    right: 8%;\n    top: 10%;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .modal-header {\n    right: 4%;\n    top: 5%;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .modal-header {\n    right: 10%;\n    top: 5%;\n  }\n}\n\n@media (max-width: 767px) {\n  .modal-header {\n    right: 3%;\n    top: 1%;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .modal-header {\n    right: 3%;\n    top: 1%;\n  }\n}\n\n.modal-header .close {\n  background: transparent;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  font-size: 20px;\n  color: white;\n  border-color: white;\n  border: 2px solid;\n  line-height: 38px;\n  transition: 0.3s;\n}\n\n@media (max-width: 767px) {\n  .modal-header .close {\n    border-color: #e12a72;\n    color: #e12a72;\n  }\n}\n\n.modal-header .close:hover {\n  rotate: 90deg;\n  border-color: #e12a72;\n  color: #e12a72;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-img {\n  border-radius: 15px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .blog-meta {\n  margin-bottom: 15px;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .blog-meta .blog-date,\n.h1-modal-box .modal-dialog .modal-content .modal-body .blog-meta .blog-cetagory {\n  font-size: 18px;\n  margin-right: 15px;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .blog-title {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n@media (max-width: 767px) {\n  .h1-modal-box .modal-dialog .modal-content .modal-body .blog-title {\n    font-size: 22px;\n  }\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item {\n  display: flex;\n  gap: 30px;\n  border: 1px solid #fa5252;\n  border-radius: 15px;\n  padding: 20px;\n  margin-top: 50px;\n  margin-bottom: 30px;\n}\n\n@media (max-width: 767px) {\n  .h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item {\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .img {\n  width: 125px;\n  height: 122px;\n  flex: 0 0 auto;\n  overflow: hidden;\n  border-radius: 15px;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .name-date {\n  margin-bottom: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .name-date .name {\n  font-size: 22px;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .name-date .date {\n  font-size: 14px;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .comment-text {\n  margin-bottom: 5px;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .reply-btn {\n  transition: 0.3s;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-item .content .reply-btn:hover {\n  color: #fa5252;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box .title {\n  font-size: 26px;\n  font-weight: 500;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box textarea {\n  width: 100%;\n  height: 80px;\n  border: none;\n  background: #f3f6f6;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  padding: 15px;\n  font-size: 12px;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box textarea::placeholder {\n  font-size: 12px;\n  color: #9c9fa1;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box button {\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: capitalize;\n  border: none;\n  outline: none;\n  padding: 8px 20px;\n  border-radius: 20px;\n  background: linear-gradient(180deg, #fa5252 0%, #e12a72 100%);\n  color: white;\n}\n\n.h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box button:hover {\n  background: linear-gradient(80deg, #fa5252 0%, #e12a72 100%);\n}\n\n.page-wrapper-2 .blog-slider-wrap .blog-progation span {\n  border: 1px solid #fa5252 !important;\n}\n\n.page-wrapper-2 .blog-slider-wrap .blog-progation span:is(.swiper-pagination-bullet-active) {\n  background-color: #fa5252;\n}\n\n.page-wrapper-2 .blog-slider-single .blog-title:hover {\n  color: #fa5252;\n}\n\n.home-3 .blog-slider-wrap .blog-progation span {\n  border: 1px solid #f95054 !important;\n}\n\n.home-3 .blog-slider-wrap .blog-progation span:is(.swiper-pagination-bullet-active) {\n  background-color: #f95054;\n}\n\n.home-3 .blog-slider-single .blog-title:hover {\n  color: #fa5252;\n}\n\n/*\n************\n*************************\n11. contact\n******************************************************* \n*************************************************************** */\n.contact-area {\n  padding: 40px 45px;\n  border-radius: 20px;\n}\n\n@media (max-width: 767px) {\n  .contact-area {\n    padding: 60px 20px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .contact-area {\n    padding: 60px 30px;\n  }\n}\n\n.contact-area .contact-title {\n  font-size: 25px;\n  font-weight: 400;\n  color: var(--body-text);\n  text-transform: capitalize;\n  margin-bottom: 13px;\n}\n\n.contact-area .contact-title-b {\n  font-size: 25px;\n  font-weight: 700;\n  text-transform: lowercase;\n  margin-bottom: 45px;\n}\n\n.contact-form .input-lebel {\n  font-size: 16px;\n  display: inline-block;\n  font-weight: 500;\n  text-transform: capitalize;\n  line-height: 1;\n}\n\n.contact-form .input-box {\n  display: block;\n  width: 100%;\n  border: none;\n  outline: none;\n  border-bottom: 1px solid #b5b5b5;\n  background: transparent;\n  height: 15px;\n  transition: 0.3s;\n  transform-origin: top;\n  font-size: 14px;\n}\n\n.contact-form .input-box:is(.height) {\n  height: 40px;\n}\n\n.bostami-contact-item {\n  display: flex;\n  gap: 20px;\n  padding: 30px;\n  border-radius: 10px;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .bostami-contact-item {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 767px) {\n  .bostami-contact-item {\n    padding: 20px;\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .bostami-contact-item {\n    padding: 30px;\n    flex-wrap: nowrap;\n  }\n}\n\n.bostami-contact-item .icon {\n  flex: 0 0 auto;\n  width: 35px;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .bostami-contact-item .icon {\n    width: 40px;\n  }\n}\n\n@media (max-width: 767px) {\n  .bostami-contact-item .icon {\n    width: 40px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .bostami-contact-item .icon {\n    width: 80px;\n  }\n}\n\n.bostami-contact-item .text .title {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 30px;\n  margin-bottom: 10px;\n}\n\n.bostami-contact-item .text span {\n  display: block;\n  font-size: 18px;\n  font-weight: 400;\n  color: #44566c;\n  line-height: 30px;\n}\n\n/*\n************\n*************************\n12. preloader\n******************************************************* \n*************************************************************** */\n/* preloader */\n#preloader {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 100%;\n  z-index: 1000000000000000000;\n  display: flex;\n}\n\n#preloader:before,\n#preloader:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 50%;\n  height: 100%;\n  z-index: -1;\n  background-color: #000;\n  -webkit-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n\n#preloader:after {\n  left: auto;\n  right: 0;\n}\n\n#preloader .loader_line {\n  margin: auto;\n  width: 1px;\n  height: 250px;\n  position: relative;\n  overflow: hidden;\n  -webkit-transition: all 0.8s ease 0s;\n  -o-transition: all 0.8s ease 0s;\n  transition: all 0.8s ease 0s;\n}\n\n.loader_line:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  width: 1px;\n  height: 0%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  transform: translateY(-50%);\n  background-color: #fff;\n  -webkit-animation: lineheight 1000ms ease-in-out 0s forwards;\n  -o-animation: lineheight 1000ms ease-in-out 0s forwards;\n  animation: lineheight 1000ms ease-in-out 0s forwards;\n}\n\n.loader_line:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 1px;\n  height: 100%;\n  background-color: #999999;\n  -webkit-transform: translateY(-100%);\n  -ms-transform: translateY(-100%);\n  -o-transform: translateY(-100%);\n  transform: translateY(-100%);\n  -webkit-animation: lineround 1200ms linear 0s infinite;\n  -o-animation: lineround 1200ms linear 0s infinite;\n  animation: lineround 1200ms linear 0s infinite;\n  animation-delay: 2000ms;\n}\n\n@keyframes lineheight {\n  0% {\n    height: 0%;\n  }\n\n  100% {\n    height: 100%;\n  }\n}\n\n@keyframes lineround {\n  0% {\n    -webkit-transform: translateY(-100%);\n    -ms-transform: translateY(-100%);\n    -o-transform: translateY(-100%);\n    transform: translateY(-100%);\n  }\n\n  100% {\n    -webkit-transform: translateY(200%);\n    -ms-transform: translateY(200%);\n    -o-transform: translateY(200%);\n    transform: translateY(200%);\n  }\n}\n\n.portfolio_list {\n  min-height: 50vh;\n}\n\n/*hiding all*/\n.preloaded .loader_line:after {\n  opacity: 0;\n}\n\n.preloaded .loader_line {\n  opacity: 0;\n  height: 100% !important;\n}\n\n.preloaded:before,\n.preloaded:after {\n  -webkit-animation: preloadedzero 300ms ease-in-out 500ms forwards;\n  -o-animation: preloadedzero 300ms ease-in-out 500ms forwards;\n  animation: preloadedzero 300ms ease-in-out 500ms forwards;\n}\n\n@keyframes preloadedzero {\n  0% {\n    width: 50%;\n  }\n\n  100% {\n    width: 0%;\n  }\n}\n\n/*\n************\n*************************\n13. blog details\n******************************************************* \n*************************************************************** */\n.blog-details-area {\n  background-color: #fff;\n}\n\n.breadcrumb-title {\n  font-size: 30px;\n  font-weight: 400;\n  text-transform: capitalize;\n  color: #000;\n  line-height: 1.33;\n  font-family: \"Roboto Slab\", serif;\n  margin-bottom: 15px;\n}\n\n@media (max-width: 767px) {\n  .breadcrumb-title {\n    font-size: 26px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .breadcrumb-title {\n    font-size: 30px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .breadcrumb-title br {\n    display: none;\n  }\n}\n\n.breadcrumb-meta-wrap .meta-item {\n  display: inline-block;\n  position: relative;\n  padding: 0 10px;\n}\n\n.breadcrumb-meta-wrap .meta-item:not(:last-child)::after {\n  position: absolute;\n  content: \"\";\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background-color: #696969;\n  top: 42%;\n  right: -4px;\n}\n\n.breadcrumb-meta-wrap .meta-item .img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.breadcrumb-meta-wrap .meta-item .img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.breadcrumb-meta-wrap .meta-item .author-name,\n.breadcrumb-meta-wrap .meta-item .date,\n.breadcrumb-meta-wrap .meta-item .comment {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 21px;\n  text-transform: capitalize;\n  color: #44566c;\n}\n\n.blog-details-inner-title {\n  font-size: 18px;\n  font-weight: 500;\n  color: #202124;\n}\n\n.blog-details-content p {\n  font-size: 15px;\n  line-height: 30px;\n  color: #77838f;\n}\n\n.blog-details-blockquote {\n  font-size: 15px;\n  font-weight: 400;\n  font-style: italic;\n  color: #202124;\n  line-height: 30px;\n  padding: 40px 58px;\n  background-color: #f3f6f6;\n}\n\n@media (max-width: 767px) {\n  .blog-details-blockquote {\n    padding: 30px 20px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .blog-details-blockquote {\n    padding: 40px 58px;\n  }\n}\n\n.blog-details-blockquote span {\n  display: block;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 20px;\n  color: #696969;\n  margin-top: 10px;\n}\n\n.blog-details-list-item-wrap li {\n  font-size: 15px;\n  line-height: 46px;\n  font-weight: 400;\n  color: #696969;\n}\n\n.blog-details-list-item-wrap li i {\n  display: inline-block;\n  font-size: 18px;\n  margin-right: 7px;\n}\n\n.blog-details-short-list li {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 46px;\n  color: #696969;\n  position: relative;\n  padding-left: 19px;\n}\n\n.blog-details-short-list li::after {\n  position: absolute;\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: #696969;\n  top: 20px;\n  left: 0;\n}\n\n.blog-details-tag {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 30px;\n  padding: 20px 0;\n  border-top: 1px solid #ecedf2;\n  border-bottom: 1px solid #ecedf2;\n}\n\n.blog-details-tag .title {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #000;\n  text-transform: capitalize;\n  margin-bottom: 0;\n}\n\n.blog-details-tag .tag-item a {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  text-transform: capitalize;\n  color: #696969;\n  background: #f0f5f7;\n  border-radius: 4px;\n  padding: 7px 20px;\n  transition: 0.3s;\n}\n\n@media (max-width: 767px) {\n  .blog-details-tag .tag-item a {\n    margin-bottom: 8px;\n  }\n}\n\n.blog-details-tag .tag-item a:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n  color: #fff;\n}\n\n.blog-details-comment-item .ratting {\n  text-align: right;\n}\n\n.blog-details-comment-item .ratting i {\n  display: inline-block;\n  font-size: 13px;\n  color: #ffc78b;\n}\n\n.blog-details-comment-item .flex {\n  display: flex;\n  gap: 32px;\n}\n\n.blog-details-comment-item .flex .img {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex: 0 0 auto;\n}\n\n.blog-details-comment-item .flex .img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.blog-details-comment-item .flex .content .name {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #202124;\n  text-transform: capitalize;\n}\n\n.blog-details-comment-item .flex .content .bio {\n  display: block;\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: capitalize;\n  line-height: 21px;\n  color: #696969;\n  margin-bottom: 18px;\n}\n\n.blog-details-comment-item .flex .content p {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 26px;\n  color: #696969;\n  margin-bottom: 0;\n}\n\n.blog-details-comment-box {\n  padding: 50px;\n  border: 1px solid #ecedf2;\n  border-radius: 8px;\n}\n\n@media (max-width: 767px) {\n  .blog-details-comment-box {\n    padding: 25px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .blog-details-comment-box {\n    padding: 50px;\n  }\n}\n\n.blog-details-comment-box .blog-details-inner-title {\n  margin-bottom: 0;\n}\n\n.blog-details-comment-box .ratting i {\n  display: inline-block;\n  font-size: 13px;\n  color: #ffc78b;\n}\n\n.blog-details-comment-box form .input-title {\n  text-transform: capitalize;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 22px;\n  color: #202124;\n  display: block;\n  margin-bottom: 3px;\n}\n\n.blog-details-comment-box form input,\n.blog-details-comment-box form textarea {\n  display: block;\n  width: 100%;\n  border: none;\n  background: #f0f5f7;\n  border-radius: 8px;\n  height: 60px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #77838f;\n  padding: 22px;\n}\n\n.blog-details-comment-box form input::placeholder,\n.blog-details-comment-box form textarea::placeholder {\n  font-size: 14px;\n  font-weight: 400;\n  color: #77838f;\n  text-transform: capitalize;\n}\n\n.blog-details-comment-box form textarea {\n  height: 195px;\n  padding: 19px 25px;\n}\n\n.blog-details-comment-box form .submit-comments {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 26px;\n  text-align: center;\n  text-transform: capitalize;\n  color: #1a1a1a;\n  background: #f8fbfb;\n  border: 2px solid #44566c;\n  border-radius: 12px;\n  padding: 12px 34px;\n  transition: 0.3s;\n}\n\n.blog-details-comment-box form .submit-comments:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n  color: #fff;\n  border-color: transparent;\n}\n\n/*\n************\n*************************\n14. sidebar\n******************************************************* \n*************************************************************** */\n.sidebar-wrap {\n  padding: 30px;\n  background: #f3f6f6;\n  border-radius: 8px;\n  margin-left: 20px;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px),\n(max-width: 767px) {\n  .sidebar-wrap {\n    margin-left: 0;\n    margin-top: 50px;\n  }\n}\n\n.sidebar-box-title {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n  color: #202124;\n  text-transform: capitalize;\n  margin-bottom: 10px;\n}\n\n.sidebar-search-box {\n  position: relative;\n}\n\n.sidebar-search-box .search-btn {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 23px;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  font-size: 18px;\n  color: #696969;\n}\n\n.sidebar-search-box .search-input {\n  width: 100%;\n  height: 60px;\n  background: #ffffff;\n  border: 1px solid #ecedf2;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n  color: #696969;\n  padding: 22px;\n  padding-left: 55px;\n}\n\n.sidebar-search-box .search-input::placeholder {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n  color: #696969;\n  text-transform: capitalize;\n}\n\n.sidebar-category li a {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 35px;\n  color: #696969;\n  text-transform: capitalize;\n  position: relative;\n  padding-left: 15px;\n  transition: 0.3s;\n}\n\n.sidebar-category li a::after {\n  position: absolute;\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background-color: #202124;\n  top: 8px;\n  left: 0;\n  transition: 0.3s;\n}\n\n.sidebar-category li a:hover {\n  color: #dd2476;\n}\n\n.sidebar-category li a:hover::after {\n  background-color: #dd2476;\n}\n\n.recent-post-item {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .recent-post-item {\n    gap: 10px;\n  }\n}\n\n.recent-post-item .img {\n  flex: 0 0 auto;\n  width: 70px;\n  height: 70px;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.recent-post-item .img a img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.recent-post-item .content .date {\n  display: block;\n  font-weight: 400;\n  font-size: 14px;\n  text-transform: capitalize;\n  color: #696969;\n  line-height: 21px;\n}\n\n.recent-post-item .content .title {\n  font-size: 15px;\n  font-weight: 400;\n  text-transform: capitalize;\n  line-height: 22px;\n  color: #202124;\n  margin-bottom: 3px;\n}\n\n.recent-post-item .content .title a {\n  text-decoration: none;\n}\n\n.recent-post-item .content .title:hover {\n  color: #dd2476;\n}\n\n.sidebar-tag a {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  color: #696969;\n  background: #fff;\n  padding: 5px 20px;\n  border-radius: 4px;\n  margin-right: 7px;\n  margin-bottom: 7px;\n  transition: 0.3s;\n}\n\n.sidebar-tag a:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n  color: #fff;\n}\n\n/*\n************\n*************************\n15. dark theme\n******************************************************* \n*************************************************************** */\n.dark-theme .overly {\n  position: fixed;\n  left: 0;\n  top: 0;\n  background: #000;\n  opacity: 0.5;\n  width: 100vw;\n  height: 100vh;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n\n.dark-theme .page-wrapper .bostami-header-wrap,\n.dark-theme .page-wrapper .bostami-parsonal-info-area,\n.dark-theme .page-wrapper .bostami-main-menu-wrap {\n  background-color: #000;\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar,\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav,\n.dark-theme .page-wrapper .bostami-parsonal-info-contact,\n.dark-theme .page-wrapper .bostami-parsonal-info-bio,\n.dark-theme .page-wrapper .bostami-parsonal-info-social-link li a,\n.dark-theme .page-wrapper .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a {\n  background-color: #1d1d1d;\n}\n\n.dark-theme .page-wrapper .bg-light-white-2,\n.dark-theme .page-wrapper .blog-slider-single,\n.dark-theme .page-wrapper .fillter-item {\n  background-color: #0d0d0d;\n}\n\n.dark-theme .page-wrapper .knowledeges-item-wrap .gk-item {\n  background-color: #1c1c1c;\n}\n\n.dark-theme .page-wrapper .bastami-main-menu ul li,\n.dark-theme .page-wrapper .bostami-contact-item {\n  background-color: #212425;\n}\n\n.dark-theme .page-wrapper .bastami-main-menu ul li.active a {\n  color: #fff;\n}\n\n.dark-theme .page-wrapper .bastami-main-menu ul li.active {\n  background-color: #1b74e4;\n}\n\n.dark-theme .page-wrapper .bastami-main-menu ul li:hover a {\n  color: #fff;\n}\n\n.dark-theme .page-wrapper .bastami-main-menu ul li:hover {\n  background-color: #1b74e4;\n}\n\n.dark-theme .page-wrapper .bostami-what-do-item,\n.dark-theme .page-wrapper .bostami-card-item,\n.dark-theme .page-wrapper .form-btn,\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a {\n  background-color: transparent;\n}\n\n.dark-theme .page-wrapper .bostami-parsonal-info-social-link li a:hover {\n  background-color: #1b74e4;\n}\n\n.dark-theme .page-wrapper .btn-1:hover {\n  background-color: #1d1d1d;\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a,\n.dark-theme .page-wrapper .btn-1,\n.dark-theme .page-wrapper .bostami-card-item .card-title,\n.dark-theme .page-wrapper .form-btn {\n  color: #fff;\n}\n\n.dark-theme .page-wrapper .bostami-parsonal-info-bio,\n.dark-theme .page-wrapper .bostami-contact-item .text span {\n  color: #a6a6a6;\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a:hover {\n  color: #fa5252;\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li.active a {\n  color: #fa5252;\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a span svg * {\n  fill: #fff;\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a span img {\n  filter: brightness(5);\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:hover a span svg * {\n  fill: #fa5252;\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li.active a span svg * {\n  fill: #fa5252;\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:hover a span img {\n  filter: saturate(25);\n}\n\n.dark-theme .page-wrapper .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:is(.active) a span img {\n  filter: saturate(25);\n}\n\n.dark-theme .page-wrapper .bostami-what-do-item,\n.dark-theme .page-wrapper .bostami-card-item,\n.dark-theme .page-wrapper .blog-slider-single,\n.dark-theme .page-wrapper .fillter-item {\n  border: 1px solid #353535;\n}\n\n.dark-theme .page-wrapper-2 .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a span img {\n  filter: brightness(5);\n}\n\n.dark-theme .page-wrapper-2 .bostami-page-area .bostami-page-wrap {\n  background: #111;\n}\n\n.dark-theme .page-wrapper-2 .main-style-2 .bostami-main-menu-wrap .bastami-main-menu ul li a span svg * {\n  fill: white;\n}\n\n.dark-theme .page-wrapper-2 .bostami-header-wrap.main-style-2 {\n  background-color: transparent;\n}\n\n.dark-theme .page-wrapper-2 .bostami-main-menu-wrap {\n  background: transparent;\n}\n\n.dark-theme .page-wrapper-2 .bostami-parsonal-info-area.bostami-parsonal-info-2-area {\n  background: transparent;\n}\n\n.dark-theme .page-wrapper-2 .bostami-page-area .bostami-parsonal-info-contact {\n  background-color: transparent;\n}\n\n.dark-theme .page-wrapper-2 .bostami-parsonal-info-contact-item .icon:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.dark-theme .home-3 .bastami-main-menu ul li:is(.active) a span svg * {\n  fill: white;\n}\n\n.dark-theme .home-3 .bastami-main-menu ul li:hover a span svg * {\n  fill: white;\n}\n\n.dark-theme .home-3 .bostami-header-wrap {\n  background: transparent !important;\n}\n\n.dark-theme .home-3 .bostami-parsonal-info-social-link li a:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.dark-theme .home-3 .bastami-main-menu ul li:is(.active) {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.dark-theme .home-3 .bastami-main-menu ul li:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.dark-theme .home-3 .bostami-parsonal-info-contact-item .icon:hover {\n  background: linear-gradient(97deg, rgb(250, 82, 82) 0%, rgb(221, 36, 118) 100%);\n}\n\n.dark-theme .home-1 .bostami-header-wrap {\n  background: transparent;\n}\n\n.dark-theme .home-1 .bastami-main-menu ul li.active a span svg * {\n  fill: white;\n}\n\n.dark-theme .home-1 .bastami-main-menu ul li a span svg *,\n.dark-theme .home-3 .bastami-main-menu ul li a span svg * {\n  fill: #a6a6a6;\n}\n\n.dark-theme .home-1 .bastami-main-menu ul li:hover a span svg * {\n  fill: white;\n}\n\n.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li a:hover {\n  color: #1b74e4;\n}\n\n.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li.active a {\n  color: #1b74e4;\n}\n\n.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li.active a span svg * {\n  fill: #1b74e4;\n}\n\n.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:hover a span svg * {\n  fill: #1b74e4;\n}\n\n.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:hover a span img {\n  filter: saturate(25);\n}\n\n.dark-theme .home-1 .mobile-menu-wrap .mobile_menu .mean-bar .mean-nav ul li:is(.active) a span img {\n  filter: saturate(25);\n}\n\n.dark-theme .h1-modal-box .modal-dialog {\n  background-color: #323232;\n}\n\n.dark-theme .h1-modal-box .modal-dialog .modal-content {\n  background-color: #323232;\n}\n\n.dark-theme .h1-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box textarea {\n  background: #000;\n  color: white;\n}\n\n.dark-theme .portfolio-modal-box .modal-dialog {\n  background-color: #323232;\n}\n\n.dark-theme .portfolio-modal-box .modal-dialog .modal-content {\n  background-color: #323232;\n}\n\n.dark-theme .portfolio-modal-box .modal-dialog .modal-content .modal-body .h1-modal-comment-box textarea {\n  background: #000;\n  color: white;\n}\n\n.dark-theme .bostami-parsonal-info-contact-item:not(:first-child) {\n  border-color: #333;\n}\n\n.dark-theme .contact-form .input-box {\n  border-bottom-color: #333;\n}\n\n.dark-theme .bostami-parsonal-info-btn .btn-2 {\n  color: #fff;\n}\n\n@media print {\n  .print-area {\n    width: 250px;\n    /* Ancho fijo */\n    height: auto;\n    /* Alto automático */\n    overflow: none;\n    /* Asegura que el contenido se muestre completamente */\n    box-sizing: border-box;\n    /* Incluye bordes y rellenos en el ancho total */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
